<template>
   <div class = "fixed-content">
      <rate-form ref="RateFormCreate" mode="BILLING" :action="doTest"/>
      <rate-form ref="RateFormChange" mode="BILLING_CHANGE" :action="doTest"/>
      <rate-form ref="RateFormCostCreate" mode="COST" :action="doTest"/>
      <rate-form ref="RateFormCostChange" mode="COST_CHANGE" :action="doTest"/>

   <div>
      <callingApiCenter :paths="['/api/w/apar/getone',
                                 '/api/w/apar/create',
                                 '/api/w/gst/WebSearchCockpit' ,
                                 '/api/w/apar/update']">
                                 <!-- '/api/w/gst/WebConfirmLoad', -->
                                 <!-- '/api/w/gst/gstBilling/update', -->
                                 <!-- '/api/w/gst/gstBillingItem/update' -->

         <md-button class="md-raised custLongButton "  @click="doAction" ><span class="icons-center material-icons">list_alt</span>Billing List</md-button>
         <md-button class="md-raised custButton "  :disabled="canLast" @click="doBack" ><span class="icons-center material-icons">fast_rewind</span>Pervious</md-button>
         <md-button class="md-raised custLongButton md-primary" v-if="paramList.loadStatus == 'CFM'" :disabled="!this.getPermission.stcClerk.view && !this.getPermission.stcAcct.edit" @click="doConfirm"><span class="icons-center material-icons">attach_money</span>Confirm AP/AR</md-button>
         <md-button class="md-raised custLongButton md-accent" v-if="paramList.loadStatus == 'BLC'" :disabled="!this.getPermission.stcClerk.view && !this.getPermission.stcAcct.edit" @click="doUnConfirm"><span class="icons-center material-icons">money_off</span>Unconfirm AP/AR</md-button> 
         <md-button class="md-raised custButton "  :disabled="canNext" @click="doNext" ><span class="icons-center material-icons">fast_forward</span>Next</md-button>


         <!-- <md-button class="md-raised custLongButton md-primary" v-if="getRole.isAcnIT" @click="doConfirmLoad" ><span class="icons-center material-icons">list_alt</span>Confirm Load</md-button>
         <md-button class="md-raised custLongButton md-accent" v-if="getRole.isAcnIT" @click="doUnConfirmLoad" ><span class="icons-center material-icons">list_alt</span>Unconfirm Load</md-button> -->

     
      </callingApiCenter>
   </div>

   <div class = "setborderInvoice">
      <callingApiCenter :paths="['/api/w/apar/update']"></callingApiCenter>
      <div class=" md-layout md-gutter md-alignment-center ">
         <md-toolbar>
            <h3 class="md-titleINV">DO#:</h3>
            <h3 class="md-titleINVCont">{{this.paramList.deliveryOrder}} </h3>
            <h3 class="md-titleINV">CustPO:</h3>
            <h3 class="md-titleINVCont">{{this.paramList.customerOrder}} </h3>
            <h3 class="md-titleINV">BK:</h3>
            <h3 class="md-titleINVCont">{{this.paramList.bookingNo}} </h3>
            <h3 class="md-titleINV">Total AR:</h3>
            <h3 class="md-titleINVCont">${{this.billingItems.billTotal}}</h3>
            <h3 class="md-titleINV">Total AP:</h3>
            <h3 class="md-titleINVCont">${{this.costItems.costTotal}}</h3>
            
         </md-toolbar>
      </div>
   </div>  

   <div class = "setborderAPAR">
      <md-toolbar>
         <h3 class="md-titleAR">== Customer Billing ==</h3>
         <md-button v-if="paramList.loadStatus == 'CFM'" :disabled="!this.getPermission.stcClerk.view" class="md-raised custButtonBillCost "  @click="doCreateBilling" ><span class="icons-center material-icons">add</span>ADD</md-button>
         <md-button v-if="selectedBilling != null && paramList.loadStatus == 'CFM'" :disabled="!this.getPermission.stcClerk.view && !this.getPermission.stcAcct.edit" class="md-raised custButtonBillCost "  @click="doChangeBilling" ><span class="icons-center material-icons">edit</span>EDIT</md-button>
         <md-button v-if="selectedBilling != null && paramList.loadStatus == 'CFM'" :disabled="!this.getPermission.stcClerk.view && !this.getPermission.stcAcct.edit"  class="md-raised custButtonBillCost "  @click="doDeleteBilling" ><span class="icons-center material-icons">delete</span>DELETE</md-button>
      </md-toolbar>
      <md-table v-model="billingItems" md-sort="name" md-sort-order="asc" md-card @md-selected="onSelectBilling">  
         <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
            <md-table-cell md-label="Doc RateType" md-sort-by="billingNumRateType">{{ item.billingNumRateType }}</md-table-cell>
            <md-table-cell md-label="Description" md-sort-by="rDesc">{{ item.rdesc }}</md-table-cell>
            <md-table-cell md-label="Maeasure Unit" md-sort-by="unit">{{ item.unit }}</md-table-cell>
            <md-table-cell md-label="Unit Price" md-sort-by="amt">{{ item.amt }}</md-table-cell>
            <md-table-cell md-label="Quantity" md-sort-by="qty">{{ item.qty }}</md-table-cell>
            <md-table-cell md-label="Total" md-sort-by="tol">{{ item.tol }}</md-table-cell>
            <md-table-cell md-label="PF" md-sort-by="pf">{{ item.pf }}</md-table-cell>
            <md-table-cell md-label="Customer" md-sort-by="partner">{{ item.partner }}</md-table-cell>
            <md-table-cell md-label="Settle Date" md-sort-by="settleDate">{{ item.settleDate | date}}</md-table-cell>
            <md-table-cell md-label="Remark" md-sort-by="remark">{{ item.remark}}</md-table-cell>
         </md-table-row>
      </md-table>
   <!-- </div>


   <div class = "setborderAPAR"> -->
      <md-toolbar>
         <h3 class="md-titleAP">=== Vendor Cost ===</h3>
         <md-button v-if="paramList.loadStatus == 'CFM'" :disabled="!this.getPermission.stcClerk.view"  class="md-raised custButtonBillCost "  @click="doCreateCost" ><span class="icons-center material-icons">add</span>ADD</md-button>
         <md-button v-if="selectedCost != null && paramList.loadStatus == 'CFM'" :disabled="!this.getPermission.stcClerk.view && !this.getPermission.stcAcct.edit" class="md-raised custButtonBillCost "  @click="doChangeCost" ><span class="icons-center material-icons">edit</span>EDIT</md-button>
         <md-button v-if="selectedCost != null && paramList.loadStatus == 'CFM'" :disabled="!this.getPermission.stcClerk.view && !this.getPermission.stcAcct.edit" class="md-raised custButtonBillCost "  @click="doDeleteCost" ><span class="icons-center material-icons">delete</span>DELETE</md-button>
      </md-toolbar>
      <md-table v-model="costItems" md-sort="name" md-sort-order="asc" md-card @md-selected="onSelectCost">
         <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
            <md-table-cell md-label="Rate Type" md-sort-by="billingNumRateType">{{ item.billingNumRateType }}</md-table-cell>
            <md-table-cell md-label="Description" md-sort-by="rDesc">{{ item.rdesc }}</md-table-cell>
            <md-table-cell md-label="Measure Unit" md-sort-by="unit">{{ item.unit }}</md-table-cell>
            <md-table-cell md-label="Unit Price" md-sort-by="amt">{{ item.amt }}</md-table-cell>
            <md-table-cell md-label="Quantity" md-sort-by="qty">{{ item.qty }}</md-table-cell>
            <md-table-cell md-label="Total" md-sort-by="tol">{{ item.tol }}</md-table-cell>
            <md-table-cell md-label="PF" md-sort-by="pf">{{ item.pf }}</md-table-cell>
            <md-table-cell md-label="Vendor" md-sort-by="partner">{{ item.partner }}</md-table-cell>
            <md-table-cell md-label="Settle Date" md-sort-by="settleDate">{{ item.settleDate | date }}</md-table-cell>
            <md-table-cell md-label="Remark" md-sort-by="remark">{{ item.remark}}</md-table-cell>
         </md-table-row>
      </md-table>
   </div>


    <!-- Load Info -->
    <!-- <div class="setborder">
    <div class="border_label"><label>Load Info</label>
    <md-button
                  class="md-icon-button updownarrow"
                  @click="doHideLoadInfo"
                  id="expand-button"
                >
             <md-icon v-if="!showLoad">keyboard_arrow_down</md-icon>
             <md-icon v-if="showLoad">keyboard_arrow_up</md-icon>
        </md-button>
    </div> -->

    <div class="itemlist">
    <div class=" md-layout md-gutter md-alignment-center ">
      <md-toolbar>
         <h3 class="md-title">Load#: {{paramList.seqNo}}</h3>
      </md-toolbar>
    </div>
    <div class="r_divider"></div>    
    <div v-if="showLoad">
    <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Load Status</label>
                 <md-input v-model="paramList.loadStatus" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Container#</label>
                 <md-input v-model="paramList.containerNo" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Chassis#</label>
                 <md-input v-model="paramList.chassisNo" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Seal#</label>
                 <md-input v-model="paramList.sealNumber" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Cont. type</label>
                 <md-input v-model="paramList.ctnrType" disabled></md-input>
            </md-field>
         </div>
    </div>      
    <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Rev Window</label>
                 <md-input v-model="paramList.receivingWindow" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Carrier</label>
                 <md-input v-model="paramList.carrier" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Load Key</label>
                 <md-input v-model="paramList.loadKey" disabled></md-input>
            </md-field>
          </div>  
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Out Gate Date</label>
                 <md-input v-model="paramList.chzStartDate" disabled></md-input>
            </md-field>
         </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>In Gate Date</label>
                 <md-input v-model="paramList.chzEndDate" disabled></md-input>
            </md-field>
         </div>
    </div>     
    <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Booking</label>
                 <md-input v-model="paramList.bookingNo" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Cargo-cut off date</label>
                 <md-input v-model="paramList.cutLFD" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Customer Order</label>
                 <md-input v-model="paramList.customerOrder" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>STC DO</label>
                 <md-input v-model="paramList.deliveryOrder" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
         </div>
    </div> 
    <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>DropOff Tml</label>
                 <md-input v-model="paramList.dropOffTerm" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Appointment</label>
                 <md-input v-model="paramList.appointment" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Appt. date</label>
                 <md-input v-model="paramList.apptDate" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Appt.Time</label>
                 <md-input v-model="paramList.apptTime" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Customer</label>
                 <md-input v-model="paramList.custId" disabled></md-input>
            </md-field>
         </div>
    </div>
    <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Driver Group</label>
                 <md-input v-model="paramList.driverGroup" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Push Status</label>
                 <md-input v-model="paramList.pushStatus" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Driver</label>
                 <md-input v-model="paramList.driverId" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Truck ID</label>
                 <md-input v-model="paramList.truckId" disabled></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Dispatcher</label>
                 <md-input v-model="paramList.dispatcher" disabled></md-input>
            </md-field>
         </div>
    </div> 
    <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
                 <label>Driver Remark</label>
                 <md-input v-model="paramList.driverRemark" disabled></md-input>
            </md-field>
         </div>
    </div> 
    </div> 
    </div>   
    <!--  End Load In -->
    <div class="itemlist">
    <div v-for="item in items" :key="item.loadKeyWithStageNo">
      <div class="md-layout md-gutter md-alignment-center ">
           <md-toolbar>
             <h3 class="md-title">{{getStageTypeInfo(item.stageType)}}</h3>

             <!-- <md-button class="md-raised custButton " v-if="!item.newitem" @click="doEdit(item)" ><span class="icons-center material-icons">create</span>Edit</md-button> -->

             <md-button
                  class="custButton md-raised"
                  @click="getBookingAssign(item)"
                  v-if="item.editing && isToShowLoadIn(item.stageType)"
                  :disabled="checkIsBookingAssigned(item)"
                  > 
                  Assign BK
              </md-button>
              <md-button
                  class="custButton md-raised"
                  @click="getBookingAssignEmptyOut(item)"
                  v-if="item.editing && isToShowEmptyOut(item.stageType)"
                  :disabled="checkIsBookingAssigned(item)"
                  > 
                  Assign BK
              </md-button>
              <md-button 
                  class="custButton md-raised"
                  @click="getBookingUnAssign(item)"
                  v-if="item.editing && isToShowLoadIn(item.stageType)"
                  :disabled="!checkIsBookingAssigned(item)"
                  > 
                  Un-Assign
                </md-button>
                <md-button 
                  class="custButton md-raised"
                  @click="getBookingUnAssignEmptyOut(item)"
                  v-if="item.editing && isToShowEmptyOut(item.stageType)"
                  :disabled="!checkIsBookingAssigned(item)"
                  > 
                  Un-Assign
                </md-button>
               -->   
             <!---<md-button class="md-raised custButton " v-if="item.editing" @click="doSave(item)" ><span class="icons-center material-icons">create</span>Save</md-button>-->
             <!--
             <md-button class="md-raised custButton " v-if="item.editing && !item.newitem" @click="doChkRemoveAndSave(item)" ><span class="icons-center material-icons">save</span>Save</md-button>
             <md-button class="md-raised custButton " v-if="item.editing && item.newitem" @click="doChkRemoveAndSave(item)" ><span class="icons-center material-icons">save</span>New</md-button>
             <md-button class="md-raised custButton " v-if="item.editing && !item.newitem" @click="doCancel(item)" ><span class="icons-center material-icons">cancel</span>Cacnel</md-button>
             -->
             <!--<md-button class="md-raised custButton " v-if="item.editing" @click="doRemove(item)" ><span class="icons-center material-icons">create</span>Remove</md-button>-->

             <!-- <md-button class="md-raised custButton " @click="doSend(item)"><span class="icons-center material-icons">send</span>SEND</md-button> -->


             <md-checkbox v-if="item.editing" v-model="item.remove">Remove</md-checkbox>
             -->
             <div class="vl"></div>
             <div style="margin-left: 10px"></div>
             <template v-if="!item.editing">
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'C')" @click="toggleItemLink1(item,'C')"><span class="icons-center material-icons">assignment_turned_in</span>CTNR</md-button>
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'CH')" @click="toggleItemLink1(item,'CH')"><span class="icons-center material-icons">assignment_turned_in</span>CHASSIS</md-button>
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'IC')" @click="toggleItemLink1(item,'IC')"><span class="icons-center material-icons">assignment_turned_in</span>INTERCHG</md-button>
             </template>
             <template v-else>
                <!--
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'C')" @click="toggleItemLink1(item,'C')"><span class="icons-center material-icons">assignment_turned_in</span>C</md-button>
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'CH')" @click="toggleItemLink1(item,'CH')"><span class="icons-center material-icons">assignment_turned_in</span>CH</md-button>
                <md-button class="md-raised custButton " :disabled="chkdisablephoto_v(item,'IC')" @click="toggleItemLink1(item,'IC')"><span class="icons-center material-icons">assignment_turned_in</span>IC</md-button>
                -->
                <div class="dropdown">
                  <md-button class="md-raised custButton" @click="doDropDown2(item)"><span class="icons-center material-icons">assignment_turned_in</span>VERIFY</md-button>
                  <!--
                  <template v-if="toShowDropDown2(item)">
                     <div id="dropdown2" class="dropdown-content2">
                     <a href="#" :disabled="chkdisablephoto_v(item,'C')" @click="toggleItemLink1(item,'C')">Container</a>
                     <a href="#" :disabled="chkdisablephoto_v(item,'CH')" @click="toggleItemLink1(item,'CH')">Chassis</a>
                     <a href="#" :disabled="chkdisablephoto_v(item,'IC')" @click="toggleItemLink1(item,'IC')">INTERCHG</a>
                     </div>
                  </template>   
               -->
                  <div id="dropdown2" class="dropdown-content2" v-if="item.showDropDown2">
                     <a href="#" :disabled="chkdisablephoto_v(item,'C')" @click="toggleItemLink1(item,'C')">Container</a>
                     <a href="#" :disabled="chkdisablephoto_v(item,'CH')" @click="toggleItemLink1(item,'CH')">Chassis</a>
                     <a href="#" :disabled="chkdisablephoto_v(item,'IC')" @click="toggleItemLink1(item,'IC')">INTERCHG</a>
                  </div>
               </div>
             </template>
             <!-- <div style="margin-left: 10px;">
               <md-button class="md-raised custLongButton md-primary" v-if="getStageStatusCode(item.stageStatus) == 'DCP'" @click="doConfirmStage(item)"><span class="icons-center material-icons">done_outline</span>Confirm Stage</md-button> 
               
             </div>              -->
             <md-button
                  class="md-icon-button"
                  @click="doHideItem(item)"
                  id="expand-button"
                >
             <md-icon v-if="!item.show">keyboard_arrow_down</md-icon>
             <md-icon v-if="item.show">keyboard_arrow_up</md-icon>
             </md-button>
             <callingApiCenter :paths="['/api/w/gst/WebSearchOneStage' ,
            '/api/w/gst/updateyardstage','/api/w/gst/createyardstage','/api/w/stc/updateDispatchSend','/api/w/DOs/WebUnAssignBooking',
            '/api/w/gst/WebConfirmLoad','/api/w/apar/create','/api/w/stc/WebStageAssignBooking','/api/w/stc/WebStageUnAssignBooking']">
            </callingApiCenter>
           </md-toolbar>
      </div>
      <div v-if="item.show && isToShowLoadIn(item.stageType)">
        <div class=" md-layout md-gutter md-alignment-center ">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
           
               <md-field>
                 <label>Recv Window</label>
                 <md-input v-model="item.receivingWindow" disabled></md-input>
               </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Container#</label>
               <md-input v-model="item.containerNo" :disabled="!item.editing"></md-input>
            </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            
            <template v-if="item.editing">
               <auto-complete-master-data-select
                           group="STC_CARRIER"
                           label="Carrier"
                           displayType="nameOnly"
                           :init-value="item.carrier"
                           :on-item-changed="handleCarrierChanged(item)"
                           >
              </auto-complete-master-data-select>
            </template>
            <template v-else>
               <md-field>
                 <label>Carrier</label>
                 <md-input v-model="item.carrier" disabled></md-input>
               </md-field>
            </template>
         
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
               </auto-complete-master-data-select>
            </template>
            <template v-else>
              <md-field>
                <label>Cont. type</label>
                <md-input v-model="item.ctnrType" disabled></md-input>
              </md-field>
            </template>
         
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Seal#</label>
               <md-input v-model="item.sealNumber" :disabled="!item.editing"></md-input>
            </md-field>
          </div>
       </div>
      
       <div class=" md-layout md-gutter md-alignment-center ">
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
           
               <md-field>
                 <label>Grade</label>
                 <md-input v-model="paramList.grade" disabled></md-input> 
               </md-field>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <md-field>
                 <label>Chassis#</label>
                 <md-input v-model="item.chassisNo" :disabled="!item.editing"></md-input>
              </md-field>
           </div>

           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <template v-if="item.editing">
                 <datepicker v-model="item.chzStartDate">
                    <label>Out Gate Date</label>
                 </datepicker>
              </template>
              <template v-else>
                 <md-field>
                   <label>Out Gate Date</label>
                   <md-input v-model="item.chzStartDate" disabled></md-input>
                 </md-field>
              </template>
           </div>

         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <template v-if="item.editing">
               <datepicker v-model="paramList.chzEndDate" >
                    <label v-bind:class="{notmatchcolor:!chkapptequalingate(item)}">In Gate Date</label>
               </datepicker>
            </template>
            <template v-else>
               <md-field>
                 <label v-bind:class="{notmatchcolor:!chkapptequalingate(item)}">In Gate Date</label>
                 <md-input v-model="paramList.chzEndDate" disabled></md-input>
               </md-field>
            </template>
         </div>


           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">

               <md-field>
                   <label>Chassis used day</label>
                   <md-input v-model="item.chzUseDay" :disabled="!item.editing"></md-input>
               </md-field>

           </div>


       </div>

       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Booking</label>
               <md-input v-model="item.bookingNo" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            
               <md-field>
                 <label>Load In Carrier</label>
                 <md-input v-model="paramList.carrier" disabled></md-input>
               </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Load In Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
               </auto-complete-master-data-select>
            </template>
            <template v-else>
              <md-field>
                <label>Load In Cont. type</label>
                <md-input v-model="item.ctnrType" disabled></md-input>
              </md-field>
            </template>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <md-field>
                 <label>Cnt Drop-off</label>
                 <md-input v-model="item.containerDropOffLocation" disabled></md-input>
               </md-field>
         </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            
               <md-field>
                   <label>Scale Date</label>
                   <md-input v-model="paramList.gwDate" disabled></md-input>
               </md-field>

           </div>
       </div>   
       <div class=" md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Appointment</label>
               <md-input v-model="item.appointment" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             <template v-if="item.editing">
               <datepicker v-model="item.apptDate" >
                    <label v-bind:class="{notmatchcolor:!chkapptequalingate(item)}">Appt. Date</label>
               </datepicker>
             </template>
             <template v-else>
               <md-field>
                 <label v-bind:class="{notmatchcolor:!chkapptequalingate(item)}">Appt. date</label>
                 <md-input v-model="item.apptDate" disabled></md-input>
               </md-field>
             </template>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Appt. time</label>
               <md-input v-model="item.apptTime" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <template v-if="item.editing">
               <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
               </auto-complete-select>
            </template> 
            <template v-else>
               <md-field>
                 <label>Rate Type</label>
                 <md-input v-model="item.freightType" disabled></md-input>
               </md-field>   
            </template>
          </div>
 
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <template v-if="item.editing">
                <auto-complete-master-data-select
                                 group="STC_CHASSIS_VENDOR"
                                 label="Chassis Vendor"
                                 :init-value="item.chassisVendor"
                                 :on-item-changed="handleChassisVendorChanged(item)"
                           >
                </auto-complete-master-data-select>
              </template> 
              <template v-else>
                <md-field>
                  <label>Chassis Vendor</label>
                  <md-input v-model="item.chassisVendor" disabled></md-input>
                </md-field>
              </template>
           </div>          
       </div>

       
       <div class="  md-layout md-gutter md-alignment-center ">
         <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
               <label>Dispatch Instruction</label>
               <md-input v-model="item.dispatcherInstruction" :disabled="!item.editing"></md-input>
            </md-field>
         </div>
       </div>   
       <div class="  md-layout md-gutter md-alignment-center ">
      
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
        
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   
      </div> 
      <div v-if="item.show && isToShowLoadOut(item.stageType)">
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Pick up terminal"
                              :init-value="item.containerPickupLocation"
                              :on-item-changed="handlePickupTermChanged(item)"
                           >
               </auto-complete-master-data-select>
               </template>
               <template v-else>
                  <md-field>
                     <label>Pick up terminal</label>
                     <md-input v-model="item.containerPickupLocation" :disabled = !item.editing></md-input>
                  </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Container #</label>
                   <md-input v-model="item.containerNo" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              
                <md-field>
                   <label>Carrier</label>
                   <md-input v-model="paramList.carrier" disabled></md-input>
                 </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                 <md-field>
                   <label>Cont. type</label>
                   <md-input v-model="item.ctnrType" disabled></md-input>
                 </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Seal #</label>
                   <md-input v-model="paramList.sealNumber" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div>
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appointment#</label>
                   <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <template v-if="item.editing">
                  <datepicker v-model="item.apptDate" >
                    <label>Appt. Date</label>
                  </datepicker>
                </template>
                <template v-else>
                  <md-field>
                   <label>Appt. date</label>
                      <md-input v-model="item.apptDate" disabled></md-input>
                   </md-field>
                </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. time</label>
                   <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
                  </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                     <label>Rate Type</label>
                     <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
         </div>
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>BOL#</label>
                   <md-input v-model="item.bolNum" disabled></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>PIN #</label>
                   <md-input v-model="item.pinNum" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
         </div>
         <div class="  md-layout md-gutter md-alignment-center ">
        
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
         
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   

      </div>
      <div v-if="item.show && isToShowEmptyIn(item.stageType)">
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Drop off terminal</label>
                   <md-input v-model="item.containerDropOffLocation" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Container #</label>
                   <md-input v-model="item.containerNo" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">       
                 <md-field>
                   <label>Carrier</label>
                   <md-input v-model="paramList.carrier" disabled></md-input>
                 </md-field>
               
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                 <md-field>
                   <label>Cont. type</label>
                   <md-input v-model="paramList.ctnrType" disabled></md-input>
                 </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Seal #</label>
                   <md-input v-model="paramList.sealNumber" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div> 
         <div class="md-layout md-gutter md-alignment-center">
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Chassis#</label>
                   <md-input v-model="item.chassisNumber" disabled></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                                 group="STC_CHASSIS_VENDOR"
                                 label="Chassis Vendor"
                                 :init-value="item.chassisVendor"
                                 :on-item-changed="handleChassisVendorChanged(item)"
                           >
                  </auto-complete-master-data-select>
              </template> 
              <template v-else>
                <md-field>
                  <label>Chassis Vendor</label>
                  <md-input v-model="item.chassisVendor" disabled></md-input>
                </md-field>
              </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
         </div>                 
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appointment#</label>
                   <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <template v-if="item.editing">
                  <datepicker v-model="item.apptDate" >
                    <label>Appt. Date</label>
                  </datepicker>
                </template>
                <template v-else>
                  <md-field>
                    <label>Appt. date</label>
                    <md-input v-model="item.apptDate" disabled></md-input>
                  </md-field>
                </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. time</label>
                   <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
                  </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
         </div>   
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Dispatch Instruction</label>
                   <md-input v-model="item.dispatchInst" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div> 
         <div class="  md-layout md-gutter md-alignment-center ">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
         
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   

      </div>
      <div v-if="item.show && isToShowEmptyOut(item.stageType)">
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <md-field>
                  <label>Container#</label>
                  <md-input v-model="item.containerNo" :disabled="!item.editing"></md-input>
               </md-field>
            </div>
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <md-field>
                 <label>Chassis#</label>
                 <md-input v-model="item.chassisNo" :disabled="!item.editing"></md-input>
              </md-field>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <template v-if="item.editing">
                <auto-complete-master-data-select
                           group="STC_CARRIER"
                           label="Carrier"
                           displayType="nameOnly"
                           :init-value="item.carrier"
                           :on-item-changed="handleCarrierChanged(item)"
                           >
                </auto-complete-master-data-select>
              </template>
              <template v-else>
                <md-field>
                  <label>Carrier</label>
                  <md-input v-model="item.carrier" disabled></md-input>
                </md-field>
              </template>
           </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
           </div>  
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
           </div>  
         </div>
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Booking</label>
                   <md-input v-model="item.bookingNo" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                 <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Cont. Type"
                              :init-value="item.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                 <md-field>
                   <label>Cont. type</label>
                   <md-input v-model="item.ctnrType" disabled></md-input>
                 </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Cnt Pick-up"
                              :init-value="item.containerPickupLocation"
                              :on-item-changed="handleCtnrPickupLocChanged(item)"
                           >
                 </auto-complete-master-data-select>
               </template>
               <template v-else>
                <md-field>
                   <label>Cnt Pick-up</label>
                   <md-input v-model="item.containerPickupLocation" :disabled = !item.editing></md-input>
                </md-field>
                </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             </div>
         </div>       
         <div class="md-layout md-gutter md-alignment-center">
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appointment#</label>
                   <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <datepicker v-model="item.apptDate" >
                    <label>Appt. Date</label>
                  </datepicker>
               </template>
               <template v-else>
                 <md-field>
                   <label>Appt. date</label>
                   <md-input v-model="item.apptDate" disabled></md-input>
                 </md-field>
               </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Appt. time</label>
                   <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Dispatcher</label>
                   <md-input v-model="item.dispatcher" disabled></md-input>
                </md-field>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
                  </auto-complete-select>               
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
             </div>
         </div>
         <div class="  md-layout md-gutter md-alignment-center ">
        
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
         
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   

      </div>
      <div v-if="item.show && (isToShowChassisIn(item.stageType) || isToShowChassisOut(item.stageType))">
         <div class="md-layout md-gutter md-alignment-center">
         
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                
                  <auto-complete-master-data-select
                              label="Chassis pickup location"
                              :prepared-options="getMasterDataAsSelectOptionByGroup('STC_TERMINAL')"
                              :init-value="item.chassisPickupLocation"
                              :on-item-changed="handleChassisPickupLocChanged(item)"
                           >
               </auto-complete-master-data-select>
               </template>
               <template v-else>
               <md-field>
                   <label>Chassis pickup location</label>
                   <md-input v-model="item.chassisPickupLocation" disabled></md-input>
                </md-field>
               </template>
             </div>
          
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Chassis pickup term"
                              :init-value="item.chassisPickupTerm"
                              :on-item-changed="handleChassisPickupTermChanged(item)"
                           >
               </auto-complete-master-data-select>
            
               </template>
               <template v-else>
                <md-field>
                   <label>Chassis pickup term</label>
                   <md-input v-model="item.chassisPickupTerm" disabled></md-input>
                </md-field>
               </template> 
               </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Chassis dropoff location"
                              :init-value="item.chassisDropOffLocation"
                              :on-item-changed="handleChassisDropOffLocChanged(item)"
                           >
               </auto-complete-master-data-select>
               </template>
               <template v-else>
               <md-field>
                   <label>Chassis dropoff location</label>
                   <md-input v-model="item.chassisDropOffLocation" disabled></md-input>
                </md-field>
               </template>
               </div>
            
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                  <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Chassis dropoff term"
                              :init-value="item.chassisDropOffTerm"
                              :on-item-changed="handleChassisDropOffTermChanged(item)"
                           >
               </auto-complete-master-data-select>
               </template>
               <template v-else>
                <md-field>
                   <label>Chassis dropoff term</label>
                   <md-input v-model="item.chassisDropOffTerm" :disabled = !item.editing></md-input>
                </md-field>
                </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Chassis#</label>
                   <md-input v-model="item.chassisNo" disabled></md-input>
                </md-field>
               </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Chassis size"
                              :init-value="item.chassisSize"
                              :on-item-changed="handleChassisSizeChanged(item)"
                           >
               </auto-complete-master-data-select>
            </template>
            <template v-else>
              <md-field>
                <label>Chassis size</label>
                <md-input v-model="item.chassisSize" disabled></md-input>
              </md-field>
            </template>

              
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
               <template v-if="item.editing">
                 <auto-complete-master-data-select
                                 group="STC_CHASSIS_VENDOR"
                                 label="Chassis Vendor"
                                 :init-value="item.chassisVendor"
                                 :on-item-changed="handleChassisVendorChanged(item)"
                           >
                 </auto-complete-master-data-select>
              </template> 
              <template v-else>
                <md-field>
                  <label>Chassis Vendor</label>
                  <md-input v-model="item.chassisVendor" disabled></md-input>
                </md-field>
              </template>
             </div>
             <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
               <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
               </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
             </div>
         </div>   
         <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Dispatch Instruction</label>
                   <md-input v-model="item.dispatchInst" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div> 
         <div class="  md-layout md-gutter md-alignment-center ">
     
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
         
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>   

      </div>
      <div v-if="item.show && ( isToShowReuse(item.stageType) || isToShowTransfer(item.stageType) )">
         <div class="  md-layout md-gutter md-alignment-center ">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Pick up location"
                              :init-value="item.containerPickupLocation"
                              :on-item-changed="handleCtnrPickupLocChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Pick up location</label>
                   <md-input v-model="item.containerPickupLocation" disabled></md-input>
                </md-field>
             </template>     
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <md-field>
                   <label>Container#/Trailer#</label>
                   <md-input v-model="paramList.containerNo" disabled></md-input>
            </md-field>
          </div>  
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <md-field>
                   <label>Carrier</label>
                   <md-input v-model="paramList.carrier" disabled></md-input>
            </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
          </div>    
         </div>    
         <div class="  md-layout md-gutter md-alignment-center ">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_TERMINAL"
                              label="Drop off location"
                              :init-value="item.containerDropOffLocation"
                              :on-item-changed="handleCtnrDropOffLocChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Drop off location</label>
                   <md-input v-model="item.containerDropOffLocation" disabled></md-input>
                </md-field>
             </template>     
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <md-field>
                   <label>Chassis #</label>
                   <md-input v-model="paramList.chassisNo" disabled></md-input>
            </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <md-field>
                   <label>Seal #</label>
                   <md-input v-model="paramList.sealNumber" disabled></md-input>
            </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
          </div>
      </div>
      <div class="md-layout md-gutter md-alignment-center">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             <md-field>
               <label>Appointment#</label>
               <md-input v-model="item.appointment" :disabled = !item.editing></md-input>
             </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             <template v-if="item.editing">
               <datepicker v-model="item.apptDate" >
                  <label>Appt. Date</label>
               </datepicker>
             </template>
             <template v-else>
               <md-field>
                  <label>Appt. date</label>
                  <md-input v-model="item.apptDate" disabled></md-input>
               </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
             <md-field>
                <label>Appt. time</label>
                <md-input v-model="item.apptTime" :disabled = !item.editing></md-input>
             </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <md-field>
                <label>BOL #</label>
                <md-input v-model="paramList.bolNum" disabled></md-input>
             </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
            <template v-if="item.editing">
                  <auto-complete-select
                           :options="dispRateCostList"
                           label="Rate Type"
                           :value="item.freightType"
                           :on-item-changed="handleRateCost(item)"
                        >
               </auto-complete-select>
               </template> 
               <template v-else>
                  <md-field>
                    <label>Rate Type</label>
                    <md-input v-model="item.freightType" disabled></md-input>
                  </md-field>   
               </template>
          </div>
      </div>      

      <div class="  md-layout md-gutter md-alignment-center ">
        
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
              <template v-if="item.editing">
                 <auto-complete-select
                      label="Driver"
                      :options="drivers"
                      :value="item.driverId"
                      :on-item-changed="changeAsgDriverId(item)"
                  >
                 </auto-complete-select>    
              </template> 
              <template v-else>
                <md-field>
                   <label>Driver</label>
                   <md-input v-model="item.driverId" disabled></md-input>
                </md-field>
              </template>
          </div>
         
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"> 
                <md-field>
                   <label>Seq#</label>
                   <md-input v-model="item.stage" disabled></md-input>
                </md-field>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
             <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="GST_STAGE_STATUS"
                              label="Stage Status"
                              :init-value="item.stageStatus"
                              :on-item-changed="handleStageStatusChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Stage Status</label>
                   <md-input v-model="item.stageStatus" disabled></md-input>
                </md-field>
             </template>
          </div>
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">  
            <template v-if="item.editing">
               <auto-complete-master-data-select
                              group="STC_COSTREL_STATUS"
                              label="Cost Rel"
                              :init-value="item.costRelevant"
                              :on-item-changed="handleCostRelChanged(item)"
                           >
               </auto-complete-master-data-select>
             </template>
             <template v-else>
               <md-field>
                   <label>Cost Rel</label>
                   <md-input v-model="item.costRelevant" disabled></md-input>
                </md-field>
             </template>
          </div> 
       </div>
       <div class="md-layout md-gutter md-alignment-center">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <md-field>
                   <label>Dispatch Instruction</label>
                   <md-input v-model="item.dispatchInst" :disabled = !item.editing></md-input>
                </md-field>
             </div>
         </div> 
    </div>
      
      
    </div>

    </div>

    <br/><br/><br/>
    </div>

</template>
<style scoped>
.dropbtn {
  background-color: #3498DB;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

/* Dropdown button on hover & focus */
.dropbtn:hover, .dropbtn:focus {
  background-color: #2980B9;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  /*display: none;*/
  /*position: absolute;*/
  /*position: relative;*/
  position: fixed;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  z-index: 100;
}
.dropdown-content2 {
  /*display: none;*/
  /*position: absolute;*/
  /*position: relative;*/
  position: fixed;
  background-color: #f1f1f1;
  min-width: 130px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  z-index: -1;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.dropdown-content2 a {
  color: black;
  padding: 12px 12px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {background-color: #ddd;}

/* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
.show {display:block;}

.itemlist {
   margin-left: -100px;
}
.setborder {
   /* border-radius: 25px;
   border: 2px solid #73AD21; */
   /*background-position: left top;*/
   /*background-repeat: repeat;*/
   padding: 20px;
   width: 1300px;
   height: 100%;
   margin-bottom: 20px;
   margin-left: -100px;
}
.setborderInvoice{
   width: 1300px;
   height: 100%;
   margin-bottom: 20px;
   margin-left: -100px;
}
.setborderAPAR {
   border-radius: 10px;
   border: solid #2621ad;
   padding: 20px;
   width: 1300px;
   height: 100%;
   margin-bottom: 20px;
   margin-left: -100px;
}

.border_label {
   width: 200px;
   background-color: #20B2AA;
   padding: 5px;
   border: 2px solid #20B2AA;
   border-top-left-radius: 5px;
   border-top-right-radius: 5px;
   height: 35px;
}
.border_label label {
   margin-left: 10px;
   color: white;
   font-weight: bold;

}

.r_divider {
   border-top: 8px solid #bbb;
   /*border-radius: 5px;*/
   border-top-right-radius: 5px;
   border-bottom-right-radius: 5px;
}

.updownarrow {
   margin-left: 50px;
   margin-top: -10px;
   position: fixed;
}

.vl {
   margin-left: 10px;
   border-left: 6px solid gray;
   height: 50px;
}

.result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 420px;
    padding: 10px;
    height: 43px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-outter-div-s {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 280px;
    padding: 10px;
    height: 43px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 2px;
}
.result-included-inner-div {
    margin-left: 5px;
    font-weight: bold;
    margin-bottom: -25px;
}
.result-included-div-span {
    margin-left: 80px; 
    margin-top: 5px;
}
.result-included-span {
    margin-left: 5px;
}
.result-included-div-span-s {
    margin-left: 8px; 
    margin-top: 5px;
}
.result-included-span-s {
    margin-left: 5px;
}
.notmatchcolor {
   color: red !important;
}

</style>

<script>

/* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  //import api from "../api";
  import { newAPIPost } from '../api';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import OutboundBooking from '../components/OutboundBooking.vue';
  import StageOutboundBooking from '../components/StageOutboundBooking.vue';
  import RateForm from '../components/GSTBillingForm.vue';


const initList = () => ({
  mode : null,
  salesOffice: null,
  billingNumRateType: null,
  carrier: null,
  loadKey: null,
  route: null,
  deliveryOrder: null,
  ctnrType: null,
  cutLFD: null,
  loadStatus: null,
  customerOrder: null,
  containerNo: null,
  chassisNo: null,
  chassisVendor: null,
  appointment: null,
  apptDate: null,
  apptTime: null,
  salesOffice: null,
  seqNo: null,
  bookingNo: null,
  receivingWindow: null,
  pushStatus: null,
  chzEndDate: null,
  chzStartDate: null,
  chzUseDay: null,
  inYardDate: null,
  dispatcher: null,
  sealNumber: null,
  driverGroup: null,
  driverId: null,
  driverRemark: null,
  custId: null,
  usedDay: null,
  grade: null,
  ctnrPickup: null,
  ctnrDropOff: null,
  gwDate: null,
  bolNum: null,
  doProcess: null,
  emptyoutContainerNo: null,
  emptyoutChassisNo: null,

});

const loadCallPageStateInfo = () => ({
    receivingWindow: null,
    loadStatus: null,
    carrier: null,
    pickupLocation: null,
    destination: null,
    containerNo: null,
    selectDType: null,
    stageType: null,
    freightType: null,
    ctnrType: null,
    stageStatus: null,
    pushStatus: null,
    apptDate: {
      startDate: null,
      endDate: null,
    },
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    driverGroup: null,
    driver: null,
    deliveryOrder: null,
    customerOrder: null,
    appointment: null
  })


const initInOutTransSave = () => ({
  bookingNo: null,
  stageStatus: null,
  stage: null,
  costRel: null,
  freightType: null,
  driverId: null,
  carrier: null,
  ctnrType: null,
  cntPickUp: null,
  cntDropOff: null,
  appointment: null,
  truckId: null,
  containerNo: null,
  chassisNo: null,
  dispatcher: null,
  apptDate: null,
  apptTime: null,
  dispatchInst: null,
})

const initChzOutSave = () => ({
   stageStatus: null,
   stage: null,
   ctnrType: null,
})

const initDispatchLoadSearch = () => ({
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driverId: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    chzStartDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: [],
    pushStatus: null,
    stageType: null,
    filter: null,
    fromPage: null,
    selectDType: null
})

const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null
})

const initLoadAsgBk = () => ({
     ctnrType: null,
     grade: null,
     carrier: null 
})

const initLoadUnAsgBk = () => ({
     deliveryOrder: null,
     bookObl: null,
     ibs: null,
     seqNo: null
})

const initUpdateSend = () => ({
     seqNo: null,
     stages: [],
})

const initPicGet = () => ({
     containerSeqNo: null
})

export default {

    data: () => ({
     paramList: initList(), 

     saveInOutTrans: initInOutTransSave(),
     saveChzOut: initChzOutSave(),
     dispatchLoadSearch: initDispatchLoadSearch(),
     searchDriverReq: getInitDriverSearch(),
     loadAsgBkInfo: initLoadAsgBk(),
     loadUnAsgBkInfo: initLoadUnAsgBk(),
     reqUpdateSend: initUpdateSend(),
     reqPicGet: initPicGet(),
     callPageStateInfo: loadCallPageStateInfo(),
     photos: [],
     loadList: [],
     params: null,
     pointer: null,
     items: null,
     loginuser: null,
     drivers: [],
     driverIds: [],
     driverNames: [],
     driverContent: [],
     dispRateCostList: [],
     dispRateCostCodes: [],
     stageTypeList: [],
     terminals: [],
     indicator: false,
     showInOutTrans: true,
     showChzOut: false,
     defaultDisabled: true,
     itemCount: null,
     driverId: null,
     carrier: null,
     disableAsgBk: true,
     disableUnAsgBk: true,
     showDropDown: false,
     showDropDown2: false,
     loadHide: false,
     isLoadIn: false,
     isLoadOut: false,
     isEmptyOut: false,
     isEmptyIn: false,
     isChassisIn: false,
     isChassisOut: false,
     isTransfer: false,
     isReuse: false,
     loadEdit: false,
     disableLoadAsgBk: true,
     disableLoadUnAsgBk: true,
     show: true,
     showLoad: true,
     showLISel: false,
     showEISel: false,
     showEOSel: false,
     showCISel: false,
     showCOSel: false,
     showTSel: false,
     showRSel: false,
     hideLoadInfo: false,
     showconfirm: true,
     debug: false,
     isfromsearch: false,
     selectedBilling: null,
     selectedCost: null,
     billingItems: [],
     costItems: [],
     billTotal: 0,
     costTotal: 0,
     profit: 0
    }),


    components: {
      callingApiCenter,
      AutocompleteCcicLocationSelect,
      OutboundBooking,
      StageOutboundBooking,
      RateForm,
    },

    watch: {
       clonedItems: {
         handler: function(after, before) {
            for (let i = 0; i < after.length; i++) {  
               if (before) {
                  if (after[i].chzStartDate) {
                     if (before[i].chzEndDate != after[i].chzEndDate || before[i].chzStartDate != after[i].chzStartDate) {
                          if (!this.isfromsearch) {
                             var t_chzuseday = this.getChassisUsedDate(after[i]).toString();
                             if (t_chzuseday != "NaN")       
                                this.items[i].chzUseDay = t_chzuseday;  
                             else
                                this.items[i].chzUseDay = "-1";        
                          } else {
                             this.isfromsearch = false;
                          }  
                     }        
                  }
               }
            //})
            }
         },
         deep: true
       } 
    },

    computed: {
        ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getGSTDriverMaster',
        'getBillRateByCategory'
      ]),

      clonedItems: function() {
         return JSON.parse(JSON.stringify(this.items))
      },

      canLast(){
        if (this.pointer > 0 && this.loadList && this.loadList.length > 1) {
           return false;
        }   
        else {
           return true;
        }      
      },


      canNext(){
         if (this.loadList && (this.pointer <  this.loadList.length - 1)) {
             return false; //endable button
         }    
         else {
             return true;  //disable button
         }        
      },


    },

    


    async mounted() {

       this.searchDriverReq.driverOffice = "STC";
       this.searchDriverReq.defaultSalesOffice = "LGB";
       this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq);
       this.updateDrivers(this.getGSTDriverMaster);
       this.getSTCTerminal();
       var dispRateCost = this.getBillRateByCategory("DRIVER"); 
       if (dispRateCost) {
          dispRateCost.forEach( (it) => {
             this.dispRateCostCodes.push(it.tagId);
             this.dispRateCostList.push(it.tagName + "(" + it.tagId + ")");
          })
       } 

        this.loadList = JSON.parse(this.$route.params.req);
        var searchCriteria = JSON.parse(this.$route.params.searchCriteria);
      //   this.dispatchLoadSearch.containerNo = searchCriteria.containerNo;
      //   this.dispatchLoadSearch.receivingWindow = searchCriteria.receivingWindow;
      //   this.dispatchLoadSearch.salesOffice = searchCriteria.salesOffice;
      //   this.dispatchLoadSearch.pickUpLocation = searchCriteria.pickUpLocation;
      //   this.dispatchLoadSearch.bookingNo = searchCriteria.bookingNo;
      //   this.dispatchLoadSearch.destination = searchCriteria.destination;
      //   this.dispatchLoadSearch.appointment = searchCriteria.appointment;
      //   this.dispatchLoadSearch.driveId = searchCriteria.driverId;
      //   this.dispatchLoadSearch.driverGroup = searchCriteria.driverGroup;
      //   this.dispatchLoadSearch.costRelevant = searchCriteria.costRelevant;
      //   this.dispatchLoadSearch.freightType = searchCriteria.freightType;
      //   this.dispatchLoadSearch.cargoCutOff.startDate = searchCriteria.cargoCutOff.startDate;
      //   this.dispatchLoadSearch.cargoCutOff.endDate = searchCriteria.cargoCutOff.endDate;
      //   this.dispatchLoadSearch.apptDate.startDate = searchCriteria.apptDate.startDate;
      //   this.dispatchLoadSearch.apptDate.endDate = searchCriteria.apptDate.endDate;
      //   this.dispatchLoadSearch.loadKey = searchCriteria.loadKey;
      //   this.dispatchLoadSearch.source = searchCriteria.source;
      //   this.dispatchLoadSearch.chassisNo = searchCriteria.chassisNo;
      //   this.dispatchLoadSearch.carrier = searchCriteria.carrier;
      //   this.dispatchLoadSearch.customerOrder = searchCriteria.customerOrder;
      //   this.dispatchLoadSearch.deliveryOrder = searchCriteria.deliveryOrder;
      //   this.dispatchLoadSearch.loadStatus = searchCriteria.loadStatus;
      //   this.dispatchLoadSearch.pushStatus = searchCriteria.pushStatus;
      //   this.dispatchLoadSearch.stageType = searchCriteria.stageType;
      //   this.dispatchLoadSearch.filter = searchCriteria.filter;
      //   this.dispatchLoadSearch.fromPage = searchCriteria.fromPage;
      //   this.dispatchLoadSearch.selectDType = searchCriteria.selectDType;

        //load Calling page state info and will send it back to call page
        this.callPageStateInfo.receivingWindow = searchCriteria.receivingWindow;
        this.callPageStateInfo.loadStatus = searchCriteria.loadStatus;
        this.callPageStateInfo.carrier = searchCriteria.carrier;
        this.callPageStateInfo.pickupLocation = searchCriteria.pickupLocation;
        this.callPageStateInfo.destination = searchCriteria.destination;
        this.callPageStateInfo.containerNo = searchCriteria.containerNo;
        this.callPageStateInfo.selectDType = searchCriteria.selectDType;
        this.callPageStateInfo.stageType = searchCriteria.stageType;
        this.callPageStateInfo.freightType = searchCriteria.freightType;
        this.callPageStateInfo.ctnrType = searchCriteria.ctnrType;
        this.callPageStateInfo.stageStatus = searchCriteria.stageStatus;
        this.callPageStateInfo.pushStatus = searchCriteria.pushStatus;
        this.callPageStateInfo.apptDate.startDate = searchCriteria.apptDate.startDate;
        this.callPageStateInfo.apptDate.endDate = searchCriteria.apptDate.endDate;
        this.callPageStateInfo.cargoCutOff.startDate = searchCriteria.cargoCutOff.startDate;
        this.callPageStateInfo.cargoCutOff.endDate = searchCriteria.cargoCutOff.endDate;
        this.callPageStateInfo.driverGroup = searchCriteria.driverGroup;
        this.callPageStateInfo.driver = searchCriteria.driver;
        this.callPageStateInfo.deliveryOrder = searchCriteria.deliveryOrder;
        this.callPageStateInfo.customerOrder = searchCriteria.customerOrder;
        this.callPageStateInfo.appointment = searchCriteria.appointment;


        console.log("loadList: " + this.loadList[0].mode);
        console.log("loadList length: " + this.loadList.length);
        this.pointer = 0;
        if (this.loadList) {
           this.params = this.loadList[0];
           if (this.params) {
             this.paramList.mode = this.params.mode;
             this.paramList.carrier = this.getDisplay("STC_CARRIER",this.params.carrier);
             this.paramList.loadKey = this.params.loadKey;
             this.paramList.route = this.params.route;
             this.paramList.deliveryOrder = this.params.deliveryOrder;
             this.paramList.ctnrType = this.getDisplay("GST_CTNRTYPE",this.params.ctnrType);
             this.paramList.cutLFD = this.params.cutLFD;
             this.paramList.loadStatus = this.params.loadStatus;
             this.paramList.customerOrder = this.params.customerOrder;
             this.paramList.containerNo = this.params.containerNo;
             this.paramList.chassisNo = this.params.chassisNo;
             this.paramList.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",this.params.chassisVendor);
             this.paramList.appointment = this.params.appointment;
             this.paramList.apptDate = this.getDate(this.params.apptDate);
             this.paramList.apptTime = this.params.apptTime;
             this.paramList.salesOffice = this.params.salesOffice;
             this.paramList.seqNo = this.params.seqNo;
             this.paramList.bookingNo = this.params.bookingNo;
             this.paramList.receivingWindow = this.params.receivingWindow;
             this.paramList.pushStatus = this.getPushStatusInfo(this.params.pushStatus);
             this.paramList.chzEndDate = this.convertDateForDatePicker(this.params.chzEndDate);
             this.paramList.chzStartDate = this.convertDateForDatePicker(this.params.chzStartDate);
             this.paramList.dispatcher = this.params.createdBy;
             this.paramList.sealNumber = this.params.sealNumber;
             this.paramList.driverGroup = this.params.driverGroup;
             this.paramList.driverId = this.params.driverId;
             this.paramList.custId = this.params.custID;
             this.paramList.usedDay = this.getChassisUsedDate(this.params);
             this.paramList.inYardDate = this.params.inYardDate;
             this.paramList.grade = this.params.grade;
             this.paramList.ctnrDropOff = this.params.dropOffTerm;
             this.paramList.ctnrPickup = this.params.pickupTerm;
             this.paramList.gwDate = this.getDate(this.params.gwDate);
             this.paramList.bolNum = this.params.bolNum;
             this.paramList.doProcess = this.params.doProcess;
             this.paramList.emptyoutContainerNo = this.params.emptyoutContainerNo;
             this.paramList.emptyoutChassisNo = this.params.emptyoutChassisNo;


            this.paramList.stageStatus = this.params.stageStatus;
            if ( this.params.billingNum != null ){
               this.paramList.billingNum = this.params.billingNum;
               const docType = "LOAD";
               const refDoc = this.paramList.seqNo;
               //const res = await api.post("/api/w/apar/getone", {docType,refDoc})
               const res = await newAPIPost("/api/w/apar/getone", {docType,refDoc})
                  .then((res) => {
                  this.showDialog = false;
                  this.$store.commit("clearApiError")
                  this.billingItems = res.billingItem
                  this.costItems = res.costItem
                 // this.billTotal = this.billingItems.reduce((acc, item) => acc + parseInt(item.tol), 0 )
                  this.billTotal = this.billingItems.reduce((acc, item) => acc + parseFloat(item.tol), 0 )
                  this.billingItems.billTotal = this.billTotal
                  this.billTotal = this.billTotal.toFixed(2);
                  this.costTotal = this.costItems.reduce((acc, item) => acc + parseFloat(item.tol), 0 )
                  this.costTotal = this.costTotal.toFixed(2);
                  this.costItems.costTotal = this.costTotal
                  this.profit = this.billTotal - this.costTotal
               });
            }
            else{
               this.billingItems = 0;
               this.costItems = 0;
            }

           }
           this.pointer = 0;
        }
      this.checkStageTypeListOpt(this.paramList.mode);  

      this.getpic(this.paramList.seqNo);
        await this.doSearch().then( () => {
            if (!this.items || this.items.length < 1) {
               if (this.paramList.mode == "YY") {
                  this.doAddStage("LI");
               } else if (this.paramList.mode == "YI") {
                  this.doAddStage("LO");
               }
            }
        })

        this.loginuser = this.getUserProfile.username;
    }, 


    methods: {

    onSelectBilling (item) {
        this.selectedBilling = item;
      },

    onSelectCost (item) {
        this.selectedCost = item;
      },

      doCreateBilling() {
          const request = {
            salesOffice: this.paramList.salesOffice,
            billingNumRateType: this.billingItems[0].billingNumRateType 
          }
          this.$refs.RateFormCreate.openDialog(request);
      },

      doChangeBilling() {

          this.$refs.RateFormChange.openDialog(this.selectedBilling);
      },

      async doDeleteBilling() {

         if (this.selectedBilling.rateType == "B001")
         {
            window.confirm("Rate Type B001 cannot be deleted!");
            return;
         }
          const req = this.selectedBilling;
          req.mode = 'D';
          //await  api.post("/api/w/apar/update", req)
          await  newAPIPost("/api/w/apar/update", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.selectedBilling = null;
            this.doTest('Item Delected!');
          });

      },

      doCreateCost() {
          const request = {
            salesOffice: this.paramList.salesOffice,
            billingNumRateType: this.billingItems[0].billingNumRateType 
          }
          this.$refs.RateFormCostCreate.openDialog(request);
      },

      doChangeCost() {
          this.$refs.RateFormCostChange.openDialog(this.selectedCost);
      },

      async doDeleteCost() {
          const req = this.selectedCost;
          req.mode = 'D';
          //await  api.post("/api/w/apar/update", req)
          await  newAPIPost("/api/w/apar/update", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.selectedCost = null;
            this.doTest('Item Delected!');
          });

      },


        doAction(){
            // this.$router.go(-1);
            var request = this.callPageStateInfo;
            this.$router.push({
               name: "Load Billing",
               params: { req: JSON.stringify(request)}               
            })
        },

        async  doTest(item){
               if ( this.paramList.billingNum != null) {
                  const docType = "LOAD";
                  const refDoc = this.paramList.seqNo;
                  //const res = await api.post("/api/w/apar/getone", {docType,refDoc});
                  const res = await newAPIPost("/api/w/apar/getone", {docType,refDoc});
                  this.billingItems = res.billingItem;
                  this.costItems = res.costItem;
                 // this.billTotal = this.billingItems.reduce((acc, item) => acc + parseInt(item.tol), 0 )
                  this.billTotal = this.billingItems.reduce((acc, item) => acc + parseFloat(item.tol), 0 )
                  this.billTotal = this.billTotal.toFixed(2);
                  this.billingItems.billTotal = this.billTotal
                  this.costTotal = this.costItems.reduce((acc, item) => acc + parseFloat(item.tol), 0 )
                  this.costTotal = this.costTotal.toFixed(2);
                  this.costItems.costTotal = this.costTotal
                  this.profit = this.billTotal - this.costTotal
               }
               else{
                  this.billingItems = 0;
                  this.costItems = 0;
               }
        },

        doBack(){
          
          this.pointer = this.pointer - 1;
          this.params = this.loadList[this.pointer];
          if (this.params) {
            this.paramList.mode = this.params.mode;
            this.paramList.carrier = this.getDisplay("STC_CARRIER",this.params.carrier);
            this.paramList.loadKey = this.params.loadKey;
            this.paramList.route = this.params.route;
            this.paramList.deliveryOrder = this.params.deliveryOrder;
            this.paramList.ctnrType = this.getDisplay("GST_CTNRTYPE",this.params.ctnrType);
            this.paramList.cutLFD = this.params.cutLFD;
            this.paramList.loadStatus = this.params.loadStatus;
            this.paramList.customerOrder = this.params.customerOrder;
            this.paramList.containerNo = this.params.containerNo;
            this.paramList.chassisNo = this.params.chassisNo;
            this.paramList.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",this.params.chassisVendor);
            this.paramList.appointment = this.params.appointment;
            this.paramList.apptDate = this.getDate(this.params.apptDate);
            this.paramList.apptTime = this.params.apptTime;
            this.paramList.salesOffice = this.params.salesOffice;
            this.paramList.seqNo = this.params.seqNo;
            this.paramList.bookingNo = this.params.bookingNo;
            this.paramList.receivingWindow = this.params.receivingWindow;
            this.paramList.pushStatus = this.getPushStatusInfo(this.params.pushStatus);
            this.paramList.chzEndDate = this.getDate(this.params.chzEndDate);
            this.paramList.chzStartDate = this.getDate(this.params.chzStartDate);
            this.paramList.dispatcher = this.params.createdBy;
            this.paramList.sealNumber = this.params.sealNumber;
            this.paramList.driverGroup = this.params.driverGroup;
            this.paramList.driverId = this.params.driverId;
            this.paramList.custId = this.params.custId;
            this.paramList.usedDay = this.getChassisUsedDate(this.params);
            this.paramList.inYardDate = this.params.inYardDate;
            this.paramList.grade = this.params.grade;
            this.paramList.ctnrDropOff = this.params.dropOffTerm;
            this.paramList.ctnrPickup = this.params.pickupTerm;
            this.paramList.gwDate = this.getDate(this.params.gwDate);
            this.paramList.bolNum = this.params.bolNum;
            this.paramList.deliveryOrder = this.params.deliveryOrder;
            this.paramList.doProcess = this.params.doProcess;

            this.paramList.billingNum = this.params.billingNum;
            this.paramList.rateType = this.params.rateType;

             const salesOffice = this.paramList.salesOffice;

            if (this.paramList.billingNum != null){
               const docType = "LOAD";
               const refDoc = this.paramList.seqNo;
               //const res = api.post("/api/w/apar/getone", {docType,refDoc})
               const res = newAPIPost("/api/w/apar/getone", {docType,refDoc})
               .then((res) => {
               this.showDialog = false;
               this.$store.commit("clearApiError")
               this.billingItems = res.billingItem
               this.costItems = res.costItem
               //this.billTotal = this.billingItems.reduce((acc, item) => acc + parseInt(item.tol), 0 )
               this.billTotal = this.billingItems.reduce((acc, item) => acc + parseFloat(item.tol), 0 )
               this.billTotal = this.billTotal.toFixed(2);
               this.billingItems.billTotal = this.billTotal
               this.costTotal = this.costItems.reduce((acc, item) => acc + parseFloat(item.tol), 0 )
               this.costTotal = this.costTotal.toFixed(2);
               this.costItems.costTotal = this.costTotal
               this.profit = this.billTotal - this.costTotal
               });
            }
            else{
                  this.billingItems = 0;
                  this.costItems = 0;
            }
         }
          this.doSearch();

        },

        async doNext(){
          this.pointer = this.pointer + 1;
          this.params = this.loadList[this.pointer];
          if (this.params) {
            this.paramList.mode = this.params.mode;
            this.paramList.carrier = this.getDisplay("STC_CARRIER",this.params.carrier);
            this.paramList.loadKey = this.params.loadKey;
            this.paramList.route = this.params.route;
            this.paramList.deliveryOrder = this.params.deliveryOrder;
            this.paramList.ctnrType = this.getDisplay("GST_CTNRTYPE",this.params.ctnrType);
            this.paramList.cutLFD = this.params.cutLFD;
            this.paramList.loadStatus = this.params.loadStatus;
            this.paramList.customerOrder = this.params.customerOrder;
            this.paramList.containerNo = this.params.containerNo;
            this.paramList.chassisNo = this.params.chassisNo;
            this.paramList.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",this.params.chassisVendor);
            this.paramList.appointment = this.params.appointment;
            this.paramList.apptDate = this.getDate(this.params.apptDate);
            this.paramList.apptTime = this.params.apptTime;
            this.paramList.salesOffice = this.params.salesOffice;
            this.paramList.seqNo = this.params.seqNo;
            this.paramList.bookingNo = this.params.bookingNo;
            this.paramList.receivingWindow = this.params.receivingWindow;
            this.paramList.pushStatus = this.getPushStatusInfo(this.params.pushStatus);
            this.paramList.chzEndDate = this.getDate(this.params.chzEndDate);
            this.paramList.chzStartDate = this.getDate(this.params.chzStartDate);
            this.paramList.dispatcher = this.params.createdBy;
            this.paramList.sealNumber = this.params.sealNumber;
            this.paramList.driverGroup = this.params.driverGroup;
            this.paramList.driverId = this.params.driverId;
            this.paramList.driverRemark = this.params.driverRemark;
            this.paramList.custId = this.params.custId;
            this.paramList.usedDay = this.getChassisUsedDate(this.params);
            this.paramList.inYardDate = this.params.inYardDate;
            this.paramList.grade = this.params.grade;
            this.paramList.ctnrDropOff = this.params.dropOffTerm;
            this.paramList.ctnrPickup = this.params.pickupTerm;
            this.paramList.gwDate = this.getDate(this.params.gwDate);
            this.paramList.bolNum = this.params.bolNum;
            this.paramList.deliveryOrder = this.params.deliveryOrder;
            this.paramList.doProcess = this.params.doProcess;
            this.paramList.billingNum = this.params.billingNum;
            this.paramList.rateType = this.params.rateType;

            const salesOffice = this.paramList.salesOffice;
            if ( this.paramList.billingNum != null){
               const docType = "LOAD";
               const refDoc = this.paramList.seqNo;
               //const res = api.post("/api/w/apar/getone", {docType,refDoc})
               const res = newAPIPost("/api/w/apar/getone", {docType,refDoc})
               .then((res) => {
               this.showDialog = false;
               this.$store.commit("clearApiError")
               this.billingItems = res.billingItem
               this.costItems = res.costItem
              // this.billTotal = this.billingItems.reduce((acc, item) => acc + parseInt(item.tol), 0 )
               this.billTotal = this.billingItems.reduce((acc, item) => acc + parseFloat(item.tol), 0 )
               this.billTotal = this.billTotal.toFixed(2);
                  this.billingItems.billTotal = this.billTotal
                  this.costTotal = this.costItems.reduce((acc, item) => acc + parseFloat(item.tol), 0 )
                  this.costTotal = this.costTotal.toFixed(2);
                  this.costItems.costTotal = this.costTotal
                  this.profit = this.billTotal - this.costTotal
               });
            }
            else{
               this.billingItems = 0;
               this.costItems = 0;
            }
          }
          await this.doSearch().then ( () => {
          if (!this.items || this.items.length < 1) {
               if (this.paramList.mode == "YY" || this.paramList.mode == "YE") {
                  this.doAddStage("LI");
               } else if (this.paramList.mode == "YI") {
                  this.doAddStage("LO");
               } else if (this.paramList.mode == "YT") {
                  this.doAddStage("T"); 
               } 
            }
         })
        },

        doAddStage(stageType) {
           var defaultCostRel = "";
           var defaultFreightType = "";
           var defaultStage = "";
           var group = "STC_LOAD_STAGES_" + this.paramList.mode;
           const defaultVal = this.getMasterDataByGroup(group).filter(it => it.tagId === stageType);
           if (defaultVal && defaultVal.length >= 0) {
              defaultCostRel = defaultVal[0].from;
              defaultFreightType = defaultVal[0].chassisVendorType;
           }

           this.isEmptyIn = false;
           this.isEmptyOut = false;
           this.isLoadIn = false;
           this.isChassisIn = false;
           this.isChassisOut = false;
           this.isTransfer = false;
           this.isLoadOut = false;
           if (stageType == "EO") {
               this.isEmptyOut = true;
           }    
           if (stageType == "EI") {
               this.isEmptyIn = true;
           }    
           if (stageType == "CI") {
               this.isChassisIn = true;
           }    
           if (stageType == "CO") {
               this.isChassisOut = true;
           }    
           if (stageType == "T") {
               this.isTransfer = true;
           }    
           if (stageType == "LO") {
               this.isLoadOut = true;
           }    
           if (stageType == "LI") {
               this.isLoadIn = true;
           }    
           if (stageType == "R") {
               this.isReuse = true;
           }
           if (this.paramList.bookingNo != null && this.paramList.bookingNo != "")
           {
              this.disableAsgBk = true;
              this.disableUnAsgBk = false;
           }
           else {
              this.disableAsgBk = false;
              this.disableUnAsgBk = true; 
           }
            //this.disableAsgBk = false;
            this.showDropDown = false;
            this.showDropDown2 = false;
            var setStage = "";
            if (this.items) {
               this.itemCount = this.items.length;
               setStage = (this.items.length + 1).toString() + "0";
            } else {
               this.itemCount = 1;
               setStage = "10";
            }

            var loadAppt = null;
            var loadApptDate = null;
            var loadApptTime = null;
            var loadDriverId = null;
            var p_containerNo = this.paramList.containerNo;
            var p_chassisNo = this.paramList.chassisNo;
            if (stageType == "LI") {
               loadAppt = this.params.appointment;
               loadApptDate = this.params.apptDate;
               loadApptTime = this.params.apptTime;
               if (this.params.driverId && this.params.driverId != "")
                  loadDriverId = this.getdriverFromUsername(this.params.driverId);
            }
            var itemBk = this.paramList.bookingNo;
            if (stageType == "EO") {
                itemBk = null; 
                p_containerNo = this.paramList.emptyoutContainerNo;
                p_chassisNo = this.paramList.emptyoutChassisNo;
            }
            var p_chzEndDate = this.paramList.chzEndDate;
            if (this.paramList.chzEndDate == null || this.paramList.chzEndDate == "") {
               p_chzEndDate = dateFormat.date(new Date());
            }
            if (!this.items) this.items = [];
            this.items.push({
            receivingWindow: this.paramList.receivingWindow,   
            stage: setStage,  
            salesOffice: this.paramList.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            //appointment: null,
            //apptDate: null,
            //apptTime: null,
            appointment: loadAppt,
            apptDate: loadApptDate,
            apptTime: loadApptTime,
            driverId: loadDriverId,
            truckId: null,
            costRelevant: (defaultCostRel && defaultCostRel != "")? this.getCostRelFromCode("Y"): null,
            freightType: (defaultFreightType && defaultFreightType != "")? this.getRateCostFromCode(defaultFreightType): null,
            dispatcherInstruction: null,
            containerPickupLocation: this.paramList.ctnrPickup,
            containerDropOffLocation: this.paramList.ctnrDropOff,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            seqNo: this.paramList.seqNo,
            user: "GST_SYSTEM",
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.paramList.deliveryOrder,
            //stageType: "I",
            stageType: stageType,
            bookingNo: this.paramList.bookingNo,
            containerNo: p_containerNo,
            ctnrType: this.paramList.ctnrType,
            bolNum: this.paramList.bolNum,
            grade: this.paramList.grade,
            sealNumber: this.paramList.sealNumber,
            chassisNo: p_chassisNo,
            chassisVendor: this.paramList.chassisVendor,
            inYardDate: this.paramList.inYardDate,
            chzEndDate: p_chzEndDate,
            chzStartDate: this.paramList.chzStartDate,
            chzUseDay: this.getChassisUsedDate(this.paramList),
            gwDate: this.paramList.gwDate,
            chzEndDate: dateFormat.date(new Date()),
            dispatcher: this.loginuser,
            carrier: null,
            editing : true,
            remove: false,
            newitem: true,
            show: true
            });

        },

        doNew(){

            //var stageTypeInName = this.getStageTypeInfo(type);
            this.showInOutTrans = true;
            this.showChzOut = false;
            this.disableAsgBk = false;
            this.itemCount = this.items.length;
            var setStage = (this.items.length + 1).toString() + "0";
            this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "I",
            stageBookingNo: this.params.bookingNo,
            editing : true,
            remove: false,
            newitem: true
            });
        },
 
        doNewOutGate() {
          this.showInOutTrans = true;
          this.showChzOut = false;
          this.disableAsgBk = false;
          var setStage = (this.items.length + 1).toString() + "0";
          this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "O",
            stageBookingNo: this.params.bookingNo,
            editing : true,
            remove: false,
            newitem: true
            });

        },
       doNewTransfer() {
          this.showInOutTrans = true;
          this.showChzOut = false;
          this.disableAsgBk = false;
          var setStage = (this.items.length + 1).toString() + "0";
          this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "T",
            stageBookingNo: this.params.bookingNo,
            editing : true,
            remove: false,
            newitem: true
            });

        },
        doNewChassisOut() {
          this.showChzOut = true;
          this.showInOutTrans = false;
          this.disableAsgBk = true;
          var setStage = (this.items.length + 1).toString() + "0";
          this.items.push({
            stage: setStage,  
            salesOffice: this.params.salesOffice,
            loadKeyWithStageNo: null,
            stageStatus: null,
            appointment: null,
            apptDate: null,
            apptTime: null,
            driverId: null,
            truckId: null,
            costRelevant: null,
            freightType: null,
            dispatcherInstruction: null,
            containerPickupLocation: null,
            containerDropOffLocation: null,
            offsiteScale: null,
            ccicDropOffLocationCode: null,
            pickupDate: null,
            // seqNo: it.loadKey,
            pickupLocationCode: null,
            pickUpLocationName: null,
            deliverLocationCode: null,
            deliverLocationName: null,
            deliveryOrder: this.params.deliveryOrder,
            stageType: "CO",
            stageBookingNo: null,
            editing : true,
            remove: false,
            newitem: true
            });

        },

         doLoadEdit() {
            this.loadEdit = true;
            this.disableLoadAsgBk = false;
            if (this.paramList.bookingNo == null || this.paramList.bookingNo == "")
               this.disableLoadUnAsgBk = true;
            else
               this.disableLoadUnAsgBk = false;   
        },

        doLoadCancel() {
            this.loadEdit = false;
            this.disableLoadAsgBk = true;
            this.disableLoadUnAsgBk = true;
        },

        doLoadSave() {

        },


      chkdisablephoto_v(item, type) {
         var mylinks = [];
         var filterVal = item.stageType;
         var filterVal1 = item.stageType;
         var chassisPhotoURLPattern = /CHA[A-Za-z]_C[0-9]{9}_[1-9]0/ig;
         var ctnrPhotoURLPattern = /CTN[A-Za-z]_C[0-9]{9}_[1-9]0/ig;
         var itPhotoURLPattern = /IC[A-Za-z]_C[0-9]{9}_[1-9]0/ig;
         if (type == "C") {
            filterVal += "CTNB" + "_" + item.loadKeyWithStageNo;
            filterVal1 += "CTNS" + "_" + item.loadKeyWithStageNo;
         }   
         if (type == "CH") {  
            filterVal += "CHAB" + "_" + item.loadKeyWithStageNo;
            filterVal1 += "CHAS" + "_" + item.loadKeyWithStageNo;
         }   
         if (type == "IC")   
            filterVal += "IC" + "_" + item.loadKeyWithStageNo;
         if (type == "C" || type == "CH")
            mylinks = this.photos.filter( it => it.photoKey === filterVal || it.photoKey === filterVal1); 
         if (type == "IC")   
            mylinks = this.photos.filter( it => it.photoKey === filterVal); 
         if (mylinks.length > 0) {
            if (mylinks[0].photoUrl != null && mylinks[0].photoUrl != "")
               return false;
         }
         return true;
      },  

      chkapptequalingate(item) {
         if (item != null)
         {
             const p_ingatedate = dateFormat.gstDateFormat(item.chzEndDate);
             const p_apptdate = dateFormat.gstDateFormat(item.apptDate);
             console.log(`comparing ingate and appt: ingate - ${p_ingatedate} appt: ${p_apptdate}`);
             if (p_ingatedate != null && p_apptdate != null)
             {
                 return p_ingatedate == p_apptdate;
             }
         } else {
            console.log(`comparing ingate and appt but item is null/empty`);
            return false;
         }
      },

      changeChkBoxCntr(item) {
          if (item.ctnrPicConfirmed != null)
             item.ctnrPicConfirmed = !item.ctnrPicConfirmed;
          else
             item.ctnrPicConfirmed = true;   
      },
      changeChkBoxChassis(item) {
          item.chassisPicConfirmed = !item.chassisPicConfirmed;
      },
      changeChkBoxIC(item) {
          item.interTicketPicConfirmed = !item.interTicketPicConfirmed;
      },

      canstageconfirm(item) {
          if (this.getStageStatusCode(item.stageStatus) == 'DCP'
             && item.taskStart && item.taskEnd
          ) return true;
          else return false;
      },

      toggleItemLink1(item,imgType) {
        var mylink = "";
        var mylinks = [];
        var title = "";
        var width;
        var height;
        var leftPos;
        var topPos;
        var settings = "";
        var userWidth = screen.availWidth;
        var userHeight = screen.availHeight;
        var filterVal = item.stageType;
        var filterVal1 = item.stageType;

        item.showDropDown2 = false;

        width =  400;
        height = 200;
        //leftPos = (userWidth - width) /2;
        //leftPos = 1500;
        leftPos = userWidth - 500;
        topPos = (userHeight - height) /2;
        settings += 'left=' + leftPos + ',top=' + topPos + ',width=' + width + ',height=' + height;
        settings += ',scrollbars=yes';
        if (imgType == "IC") {
             title = "Interchange Ticket";
             //mylink = this.getpic(item,"IC");
             filterVal += "IC" + "_" + item.loadKeyWithStageNo;
             mylinks = this.photos.filter( it => it.photoKey === filterVal); 
             if (mylinks.length > 0) {
               //console.log("mylink item: " + mylinks[0]);
               //console.log("mylink photoUrl:" + mylinks[0].photoUrl);
               mylink = mylinks[0].photoUrl;
             }
             //console.log("mylink: " + mylink);
        }    
          if (imgType == "C") {
             title = "Container# Image";
             //mylink = this.getpic(item,"C");
             filterVal += "CTNB" + "_" + item.loadKeyWithStageNo;
             filterVal1 += "CTNS" + "_" + item.loadKeyWithStageNo;
             //console.log("filterVal: " + filterVal);
             //console.log("photos before process: " + JSON.stringify(this.photos));
             mylinks = this.photos.filter( it => it.photoKey === filterVal || it.photoKey === filterVal1); 
             //console.log("mylinks length: " + mylinks.length + ", mylinks: " + JSON.stringify(mylinks));
             if (mylinks.length > 0) {
               //console.log("mylink item: " + mylinks[0]);
               //console.log("mylink photoUrl:" + mylinks[0].photoUrl);
               mylink = mylinks[0].photoUrl;
             }
             //console.log("mylink: " + mylink);
          }
          if (imgType == "CH") {
             title = "Chassis# Image";
             filterVal += "CHAB" + "_" + item.loadKeyWithStageNo;
             filterVal1 += "CHAS" + "_" + item.loadKeyWithStageNo;
             //console.log("filterVal: " + filterVal);
             //console.log("photos before process: " + JSON.stringify(this.photos));
             mylinks = this.photos.filter( it => it.photoKey === filterVal || it.photoKey === filterVal1); 
             if (mylinks.length > 0) {
               //console.log("mylink item: " + mylinks[0]);
               //console.log("mylink photoUrl:" + mylinks[0].photoUrl);
               mylink = mylinks[0].photoUrl;
             }
             //console.log("mylink: " + mylink);
          }        
        if (! window.focus)return true;
           var href;
        if (typeof(mylink) == 'string') href=mylink;
        else href=mylink.href; 
        //window.open(href, title, 'width=400,height=200,scrollbars=yes'); 
        //console.log("href: " + href);
        if (href.toString().indexOf('http') < 0) {
           //console.log("index: " + href.toString().indexOf('http'));
           alert("No Picture to verify");
        }   
        else {
          //window.open(href, title, settings,true);
          //var contents = '<img src="' + href + '"></img>';
          //console.log("mylinks length: " + mylinks.length + "mylinks: " + JSON.stringify(mylinks));
          if (mylinks && mylinks.length > 0) {
              var contents = "";
            //   for (var i=0; i < mylinks.length; i++) {
            //      var content = mylinks[i];
            //      console.log("mylinks (item): " + JSON.stringify(content));
            //      contents += '<div>' + content.photoKey + ' ' + content.photoUrl + '</div><img style="height:500px;width:800px" src="' + content.photoUrl + '"></img><div></div>';
            //   }
              mylinks.forEach( (it) => {
                 //console.log("mylinks (item): " + JSON.stringify(it));
                 contents += '<div>' + it.photoKey + ' ' + it.photoUrl + '</div><div style="margin-top:20px;margin-bottom:20px;"><img style="height:800px;width:1000px" src="' + it.photoUrl + '"></img></div>';
              });
          }
          //console.log("contents: " + contents);
          var previewWindow = window.open('','Preview',settings,true);
          previewWindow.document.body.innerHTML = contents;
        }
        return false; 

      },

      async getpic(seqNo) {
         //console.log("photo seqNo: " + seqNo);
         this.reqPicGet.containerSeqNo = seqNo;
         //var filterVal = item.stageType;
         //var retVal = "";
         //await api.post('/api/w/ccic/photo/get', this.reqPicGet).then ( (res) => {
         await newAPIPost('/api/w/ccic/photo/get', this.reqPicGet).then ( (res) => {
            this.photos = res;
            //console.log("photos: " + JSON.stringify(this.photos));
         })
      },
      // async getpic(item,imgtype) {
      //    this.reqPicGet.containerSeqNo = item.seqNo;
      //    var filterVal = item.stageType;
      //    var retVal = "";
      //    await api.post('/api/w/ccic/photo/get', this.reqPicGet).then ( (res) => {
      //         if (imgtype == "C") {
      //            filterVal += "CTN" + "_" + item.loadKeyWithStageNo;
      //            console.log("filterVal: " + filterVal); 
      //            console.log("getpic res: " + JSON.stringify(res));                
      //            retVal = res.filter( it => it.photoKey === filterVal)[0].photoUrl;
      //            console.log("C retVal: " + JSON.stringify(retVal));
      //            return JSON.stringify(retVal);
      //         } else if (imgtype == "CH") {
      //            filterVal += "CHA" + "_" + item.loadKeyWithStageNo;
      //            retVal = res.filter( photoKey == filterVal ).photoUrl;
      //            console.log("CH retVal: " + retVal);
      //            return retVal;
      //         } else if (imgtype == "IC") {
      //            filterVal += "IC" + "_" + item.loadKeyWithStageNo;
      //            retVal = res.filter( photoKey == filterVal ).photoUrl;
      //            console.log("IC retVal: " + retVal);
      //            return retVal;
      //         } else {
      //            return "";
      //         }   
      //       }) 
 
      // },


        async doLoadSend() {
           var unsave = false;
           
           this.reqUpdateSend.seqNo = this.paramList.seqNo;
           //api.post('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
           newAPIPost('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
              
           }) 
        },

        async doSend(item) {
           var hasReqField = false;
           const msg_li_eo = "booking, Appt Date, and driver";
           const msg_lo_ei_ru_tf = "Appt Date and driver";
           const msg_chzEndDate = " and ingate";
           const msg_ci_co = "driver";
           var msg_head = "Please ensure ";
           var msg_tail = " been assigned, then SAVE before process SEND!!";
           var msg = "";

           if (item.stageType == "LI" || item.stageType == "EO") {
              if ((item.driverId && item.driverId != "") && (item.bookingNo && item.bookingNo != "")
                          && (item.chzEndDate && item.chzEndDate != "") 
                          && (item.apptDate && item.apptDate != "") && !item.newitem) {
                             hasReqField = true;
                          }             
                          else {
                             msg = msg_head + msg_li_eo + msg_chzEndDate + msg_tail;     
                          }
           } else if (item.stageType == "LO" || item.stageType == "EI" || item.stageType == "R" || item.stageType == "T") {
              if ((item.driverId && item.driverId != "") && (item.apptDate && item.apptDate != "") 
                  && (item.chzEndDate && item.chzEndDate != "") 
                  && !item.newitem) {
                             hasReqField = true;
                          }             
                          else {
                             msg = msg_head + msg_lo_ei_ru_tf + msg_chzEndDate + msg_tail;     
                          }
            
           } else if (item.stageType == "CI" || item.stageType == "CO") {
              if ((item.driverId && item.driverId != "") 
                  && (item.chzEndDate && item.chzEndDate != "") 
                  && !item.newitem) {
                             hasReqField = true;
                          }             
                          else {
                             msg = msg_head + msg_ci_co + msg_chzEndDate + msg_tail;     
                          }
            
           } else { msg = "No such stage type!!"}
           
           if (hasReqField) {
             this.reqUpdateSend.stages.push(item.loadKeyWithStageNo);
             //console.log("send stages: " + JSON.stringify(this.reqUpdateSend.stages));
             //api.post('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
             newAPIPost('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ( (res) => {
                    alert("Stage status updated to 'Dispatched'");
                    this.doSearch();
                    //this.doChkRemoveAndSave(item);
             }) 
           } else {
             alert(msg);
           }

        },

        async doSendAll() {
           var nodriver = false;
           var hasnewitem = false;
           this.reqUpdateSend.seqNo = this.paramList.seqNo;
           this.reqUpdateSend.stages = [];
           this.items.forEach( (it) => {
             if (it.driverId == null || it.driverId == "") {nodriver = true;}
             if (it.newitem) {hasnewitem = true;}
             if (it.loadKeyWithStageNo) {
                var foundObj = this.reqUpdateSend.stages.filter( it => it === it.loadKeyWithStageNo );
                //console.log("foundObj: " + foundObj.length)
                if (foundObj.length == 0)
                   this.reqUpdateSend.stages.push(it.loadKeyWithStageNo); 
             }   
           }) 
           if (!nodriver && !hasnewitem) {
             //api.post('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ((res) => {
             newAPIPost('/api/w/stc/updateDispatchSend', this.reqUpdateSend).then ((res) => {
               alert("Load and Stage status updated to 'Dispatched'");
               this.doSearch();
               //this.items.forEach( (it) => {
               //   this.doChkRemoveAndSave(it);
               //})
             })
           } else {
             //if (nodriver)
                alert("Please Save any NEW stage and assign driver in all stages before process SEND ALL!!");
             //if (hasnewitem)
             //   alert("Found NEW stage, please Save before SEND!");   
           }   
        },


        changeAsgDriverId(item) {
           return (driver) => {
               item.driverId = driver;
               //item.stageStatus = "ASG";
               //this.handleStageStatusChanged(item);
               //console.log("Asg driver Id: " + item.driverId)
           }
        },

        getLoadBookingAssign() {
         var loads = [];
         this.loadAsgBkInfo.grade = this.paramList.grade;
         this.loadAsgBkInfo.ctnrType = this.paramList.ctnrType;
         this.loadAsgBkInfo.carrier = this.paramList.carrier;
         loads.push(this.loadAsgBkInfo);
         if (this.paramList.mode == "YY")
            this.$refs.OutboundBooking.openDialog(loads);
         if (this.paramList.mode == "YI")
            this.$refs.OutboundBookingYI.openDialog(loads);
         if (this.paramList.mode == "YT")
            this.$refs.OutboundBookingYT.openDialog(loads);
         if (this.paramList.mode == "YE")
            this.$refs.OutboundBookingYE.openDialog(loads);          
        },

        getLoadBookingUnAssign() {
         if (!window.confirm('Unassign the Load In booking?')) {
           return;
         }
        
         //const load = this.getSelectedItems
         //var loads = [];
         //this.loadUnAsgBkInfo.deliveryOrder = this.paramList.deliveryOrder;
         //this.loadUnAsgBkInfo.bookObl = this.paramList.bookingNo;
         //this.loadUnAsgBkInfo.ibs = this.paramList.ibs;
         //this.loadUnAsgBkInfo.seqNo = this.paramList.seqNo;
         //loads.push(this.loadUnAsgBkInfo);
         const office = 'LGB'
         //const si = loads[0].deliveryOrder
         //const obk = loads[0].bookObl
         //const ibds = loads[0].ibs
         //const usr = 'GST_SYSTEM'
         //const seqn = loads[0].seqNo
         const si = this.paramList.deliveryOrder;
         const obk = this.paramList.bookingNo;
         const usr = 'GST_SYSTEM';
         const seqn = this.paramList.seqNo;
         //console.log("Set load Unassign");
         const request = {
           salesOffice: office,
           deliveryOrder: si,
           //ibs: ibds,
           user: usr,
           seqNo: seqn,
         };

         //console.log(JSON.stringify(request));
         //api.post("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
         newAPIPost("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            this.action(si, obk, 'UASN', seqn);
    
 
         });

        },
         getChassisUsedDate(item){
          console.log("chzStartDate: " + item.chzStartDate + " chzEndDate: " + item.chzEndDate + " chzUseDay: " + item.chzUseDay);
          //if (item && item.chzUseDay == null) {
          if (item) {  
             if (item.chzStartDate != null) {
               if (item.chzEndDate == null)
               {
                 //console.log("getchassisuseddate: chzEndDate is null"); 
                 return moment().diff(moment(item.chzStartDate), 'days') + 1;
               }
               else
               {
                  //console.log("getchassisuseddate: chzEndDate is not null"); 
                 return moment(item.chzEndDate).diff(moment(item.chzStartDate), 'days') + 1;
               }
            } else {
               //console.log("chzStart is null");
               //alert("Out gate date needs to be filled to get Chassis use day!");
               return 0;
            }
          } else {
             //console.log("item is null") 
             //alert("Chassis use day unable to find without stage info!");
             return 0;
          }
        },

         async updateDrivers(itemsSource) {
          var items = itemsSource;
          if (items && items.length > 0) {  
             items.forEach((it) => {
                var driverInfo = it.shortId + "(" + it.userName + ")";
                this.drivers.push(driverInfo);
                this.driverIds.push(it.driverId);
                this.driverNames.push(it.userName);
                this.driverContent.push(driverInfo);
             })
          } else {
             //await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
             await newAPIPost('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
                 .then ( (driverinfo) => {
                    if (driverinfo) {
                        driverinfo.forEach( (it) => {
                            //console.log("driver: " + it.shortId);
                            var driverInfo = it.shortId + "(" + it.userName + ")";
                            this.drivers.push(driverInfo);
                            this.driverIds.push(it.driverId);
                            this.driverNames.push(it.userName);
                            this.driverContent.push(driverInfo);
                        })
                    }
             });
          }
          //console.log("drivers: [[" + this.drivers + "]]");
          // console.log("update drivers itemsource: " + JSON.stringify(itemsSource));
          // var items = JSON.stringify(itemsSource);
          // var items1 = JSON.parse(items);
          // console.log("update drivers: " + items + ", " + items1);
          // // items.forEach(it => {
             
          // // })
          // console.log("items1 length: " + items1.length);
          // items1.forEach((it) => {
          //    console.log("items: " + JSON.stringify(it.shortId));
          //    var driverinfo = JSON.stringify(it.shortId);
          //    this.drivers.push(driverinfo);
          // })
          // //this.drivers = items;
          // console.log("drivers: " + this.drivers);
          
         //  await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
         //         .then ( (driverinfo) => {
         //            if (driverinfo) {
         //                driverinfo.forEach( (it) => {
         //                    console.log("driver: " + it.shortId);
         //                    this.drivers.push(it.shortId + "(" + it.userName + ")");
         //                    this.driverIds.push(it.driverId);
         //                    this.driverNames.push(it.userName);
         //                    this.driverContent.push(it.shortId + "(" + it.userName + ")");
         //                })
         //            }
         //         });
         //  console.log("drivers: [[" + this.drivers + "]]");
        },

        doEdit(item){
            //console.log(item);

            if (item.stageStatus == 'STC' || item.stageStatus == 'SUC'  )
              {
                alert('The stage has been confirmed or under check, it can not be changed this time!');
                return;
              }
            item.editing = true;
            item.remove = false;
            this.indicator = true;
            //console.log("edit booking: " + item.bookingNo);
            if (item.stageType == "LI" || item.stageType == "EO") {
               if (item.bookingNo != null && item.bookingNo != "") {
                  this.disableAsgBk = true;
                  this.disableUnAsgBk = false;
               }   
               else {
                  this.disableAsgBk = false;  
                  this.disableUnAsgBk = true; 
               }   
            } else {
               this.disableAsgBk = true;
               this.disableUnAsgBk = true; 
            }
          
        },

        doSave(item)
        {
         //console.log("freight type: " + item.freightType);
          
         if (item.stageType == "LI" && item.chzUseDay && !/^[0-9]+$/.test(item.chzUseDay)) {
            alert("Please only input numeric char for Chassis Use Day!");
            return;
         }
         if (item.stageType == "LI" && item.chzUseDay <=0 || item.chzUseDay > 10) {
            alert("Warning: Chassis use day is less than 0 or greater than 10!");
         }

          if (item.loadKeyWithStageNo != null)
          {
            //update
            //console.log("item remove: " + item.remove + ", carrier: " + item.carrier);
              const request = {
            companyOffice : 'GST_' + this.params.salesOffice,
            loadKey : this.params.loadKey, 
            seqNo: this.params.seqNo,
            loadKeyWithStageNo: item.loadKeyWithStageNo,
            stageStatus: this.getStageStatusCode(item.stageStatus),
            appointment: item.appointment,
            apptDate: dateFormat.getLocalDate(item.apptDate),
            apptTime: item.apptTime,
            //driverId: this.driverId,
            driverId: (item.driverId && item.driverId != "")? this.getdriverUserNameFromDriver(item.driverId): item.driverId,
            truckId: item.truckId,
            costRelevant: item.costRelevant,
            freightType: this.getRateCostCode(item.freightType),
            chassisVendor: this.getchassisVendorCode(item.chassisVendor),
            dispatcherInstruction: item.dispatcherInstruction,
            containerPickUpLocation: item.containerPickupLocation,
            containerDropOffLocation: item.containerDropOffLocation,
            offsiteScale: item.offsiteScale,
            ccicDropOffLocationCode: item.ccicDropOffLocationCode,
            pickupDate: dateFormat.getLocalDate(item.pickupDate),
            // seqNo: it.loadKey,
            pickupLocationCode: item.pickupLocationCode,
            pickUpLocationName: item.pickUpLocationName,
            deliverLocationCode: item.deliverLocationCode,
            deliverLocationName: item.deliverLocationName,
            deliveryOrder: item.deliveryOrder,
            //stageType: item.stageType,
            stageType: item.type,
            //bookingNo: item.stageBookingNo,
            bookingNo: item.bookingNo,
            //carrier: this.carrier,
            carrier: item.carrier,
            pinNum: item.pinNum,
            bolNum: item.bolNum,
            //chzEndDate: item.chzEndDate,
            chzEndDate: this.convertDateForConfirm(item.chzEndDate,"-"),
            chzStartDate: this.convertDateForConfirm(item.chzStartDate,"-"),
            chzUseDay: item.chzUseDay,
            chassisPickupLocation: item.chassisPickupLocation,
            chassisPickupTerm: item.chassisPickupTerm,
            chassisDropOffLocation: item.chassisDropOffLocation,
            chassisDropOffTerm: item.chassisDropOffTerm,
            chassisSize: this.getChassisSizeCode(item.chassisSize),
            ctnrPicConfirmed: item.ctnrPicConfirmed,
            chassisPicConfirmed: item.chassisPicConfirmed,
            interTicketPicConfirmed: item.interTicketPicConfirmed,
            dispatcher: item.dispatcher,
            containerNo: item.containerNo,
            chassisNo: item.chassisNo,
            sealNumber: item.sealNumber,
            ctnrType: this.getContentFromBrace(item.ctnrType),
            carrier: item.carrier,
            disabled: item.remove
            }
            if (request.stageTypeWithStatus == null) 
            {request.stageTypeWithStatus = this.params.mode}
            request.mode = this.params.mode;
            request.action = 'CHANGE';


          //console.log(request);
         
      
        // await Promise.all(this.getEditingItems.map(it => api.post('/api/w/ccic/application/update', it)));
         
         //api.post("/api/w/gst/createyardstage", request)
         newAPIPost("/api/w/gst/createyardstage", request)
          .then(() => {
            //this.paramList.chzEndDate = item.chzEndDate;
            //this.paramList.chzStartDate = item.chzStartDate;
            this.$store.commit('clearApiError');
            this.doSearch();
             item.editing = false;
             this.paramList.chzEndDate = item.chzEndDate;
             this.paramList.chzStartDate = item.chzStartDate;
          });
          }
          else
          {
            //create
            //console.log("bookingNo: " + item.stageBookingNo + " driverId: " + item.driverId);
            const req = {
            companyOffice : 'GST_' + this.params.salesOffice,
            loadKey : this.params.loadKey || this.params.seqNo,
            stageStatus: this.getStageStatusCode(item.stageStatus),
            appointment: item.appointment,
            apptDate: dateFormat.getLocalDate(item.apptDate),
            apptTime: item.apptTime,
            //driverId: this.driverId,
            driverId: this.getdriverUserNameFromDriver(item.driverId),
            carrier: item.carrier,
            truckId: item.truckId,
            costRelevant: item.costRelevant,
            freightType: this.getRateCostCode(item.freightType),
            chassisVendor: this.getchassisVendorCode(item.chassisVendor),
            dispatcherInstruction: item.dispatcherInstruction,
            containerPickUpLocation: item.containerPickupLocation,
            containerDropOffLocation: item.containerDropOffLocation,
            offsiteScale: item.offsiteScale,
            ccicDropOffLocationCode: item.ccicDropOffLocationCode,
            pickupDate: dateFormat.getLocalDate(item.pickupDate),
            // seqNo: it.loadKey,
            pickupLocationCode: item.pickupLocationCode,
            pickUpLocationName: item.pickUpLocationName,
            deliverLocationCode: item.deliverLocationCode,
            deliverLocationName: item.deliverLocationName,
            deliveryOrder: item.deliveryOrder,
            stageType: item.stageType,
            //bookingNo: item.stageBookingNo,
            bookingNo: item.bookingNo,
            pinNum: item.pinNum,
            bolNum: item.bolNum,
            //chzEndDate: item.chzEndDate,
            chzEndDate: this.convertDateForConfirm(item.chzEndDate,"-"),
            chzStartDate: this.convertDateForConfirm(item.chzStartDate,"-"),
            chzUseDay: item.chzUseDay,
            chassisPickupLocation: item.chassisPickupLocation,
            chassisPickupTerm: item.chassisPickupTerm,
            chassisDropOffLocation: item.chassisDropOffLocation,
            chassisDropOffTerm: item.chassisDropOffTerm,
            chassisSize: this.getChassisSizeCode(item.chassisSize),
            ctnrPicConfirmed: item.ctnrPicConfirmed,
            chassisPicConfirmed: item.chassisPicConfirmed,
            interTicketPicConfirmed: item.interTicketPicConfirmed,
            dispatcher: this.loginuser,
            ctnrType: this.getContentFromBrace(item.ctnrType),
            disabled: item.remove,
            }
            // if (this.params.mode == "YT")
            // {
            //   req.stageType = "T"
            // }
            // else
            // {
            //   req.stageType = "IN"
            // }
            if (req.stageTypeWithStatus == null) 
            {req.stageTypeWithStatus = this.params.mode}
            req.mode = this.params.mode;
            req.action = 'CREATE';
            //console.log(req);
             //api.post("/api/w/gst/createyardstage", req)
             newAPIPost("/api/w/gst/createyardstage", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
             item.editing = false;
             this.paramList.chzEndDate = item.chzEndDate;
             this.paramList.chzStartDate = item.chzStartDate;
            
          });
          }

        },

      doAddLoadOut() {
           this.showDropDown = false;
      },

    
      doChkRemoveAndSave(item) {
         var index = 0;
         var removeIndx = 0;
         if (item.remove == false) {
            this.doSave(item);
         }
         else {
            if (item.newitem == true) {
               removeIndx = this.getItemIndx(index, item.stage);
               //console.log("indx: " + removeIndx);
               if (removeIndx > -1)
                  this.items.splice(removeIndx, 1);
               //console.log("items length after remove: " + this.items.length);
               //this.items.forEach((it) => {
                //  console.log("item: " + JSON.stringify(it));
               //})
            } else {
               this.doSave(item);
            }
         }
      },

      doHideItem(item) {
         // var itemIndx = 0;
         // var found = false;
         // var searchStage = item.stage;
         // var setVal = false;
         // this.itemToHideStage.forEach( (it) => {
         //    if (it != searchStage && !found) {
         //       itemIndx += 1;
         //    } else {
         //       console.log("itemToHide index: " + itemIndx);
         //       found = true;
         //    }
         // })
         // setVal = !this.itemToHide[itemIndx];
         // console.log("setVal: " + setVal);
         // this.itemToHide[itemIndx] = setVal;
         // //return returnVal;
         item.show = !item.show;
         if (!item.show)
           item.showDropDown2 = false;
      },

      doHideLoadInfo() {
         this.showLoad = !this.showLoad;
      },

   doConfirmLoad() {
         // if (this.paramList.loadStatus != "DCP"){
         //    window.confirm('LoadStatus is not DCP')
         //    return;
         // }
         // if (this.paramList.doProcess != "O"){
         //    window.confirm('DO process is not Open(O)!')
         //    return;
         // }

         var billngDate = " "
         if ( this.paramList.chzEndDate == " " || this.paramList.chzEndDate == null)
         {
            billngDate = moment(moment().endOf('week').toDate()).format('M/D/YYYY')
         }
         else
         {
            billngDate = this.convertDateForConfirm(this.paramList.chzEndDate,"-")
         }

         const seqNo = this.paramList.seqNo;
         //api
         //   .post("/api/w/apar/create", {
         newAPIPost("/api/w/apar/create", {
               mode: "loadCFM",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               billingDate: billngDate,
               refDoc: seqNo,
               seqNo: seqNo,
               deliveryOrder: this.paramList.deliveryOrder,
               salesOffice: this.paramList.salesOffice,
            })
            .then((res) => {
               this.showDialog = true;
               this.$store.commit("clearApiError");
               this.paramList.loadStatus = "CFM";
               this.params.loadStatus = "CFM";
               window.confirm(res);
            });
         this.doSearch();
        
      },

   doUnConfirmLoad() {
         // if (this.paramList.loadStatus != "CFM"){
         //    window.confirm('LoadStatus is not CFM')
         //    return;
         // }
         // if (this.paramList.doProcess != "O"){
         //    window.confirm('DO process is not Open(O)!')
         //    return;
         // }

         const seqNo = this.paramList.seqNo;
         //api
         //   .post("/api/w/apar/create", {
         newAPIPost("/api/w/apar/create", {
               mode: "loadUnCFM",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               refDoc: seqNo
            })
            .then((res) => {
               this.showDialog = true;
               this.$store.commit("clearApiError");
               this.paramList.loadStatus = "DCP";
               this.params.loadStatus = "DCP";
               window.confirm(res);
            });
         this.doSearch();
        
      },

      doConfirm() {
         if (this.paramList.loadStatus != "CFM"){
            window.confirm('LoadStatus is not Confirm(CFM)')
            return;
         }
         if (this.paramList.doProcess != "O"){
            window.confirm('DO process is not Open(O)!')
            return;
         }

         const seqNo = this.paramList.seqNo;
         //api
         //   .post("/api/w/apar/create", {
         newAPIPost("/api/w/apar/create", {
               mode: "APARCFM",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               billingDate: this.paramList.chzEndDate,
               refDoc: seqNo,
               seqNo: seqNo,
               deliveryOrder: this.paramList.deliveryOrder,
               salesOffice: this.paramList.salesOffice,
               billingNum: this.paramList.billingNum,
               rateType: this.paramList.rateType
            })
            .then((res) => {
               this.showDialog = true;
               this.$store.commit("clearApiError");
               this.paramList.loadStatus = "BLC";
               this.params.loadStatus = "BLC";
               window.confirm(res);
               this.doSearch();
            });

         // api
         //    .post("/api/w/gst/WebConfirmLoad", {
         //       mode: "APARCFM",
         //       user: "GST_SYSTEM",
         //       username: this.getUserProfile.username,
         //       // billingDate: dateFormat.getLocalDateOnly(moment().toDate()),
         //       billingDate: this.paramList.chzEndDate,
         //       refDoc: seqNo,
         //       seqNo: seqNo,
         //       deliveryOrder: this.paramList.deliveryOrder,
         //       salesOffice: this.paramList.salesOffice,
         //       billingNum: this.paramList.billingNum
         //    })
         //    .then((res) => {
         //       this.showDialog = true;
         //       this.$store.commit("clearApiError");
         //       this.paramList.loadStatus = "BLC";
         //       this.params.loadStatus = "BLC";
         //       window.confirm(res);
         //       this.doSearch();
         //    });
         this.doSearch();
        
      },

      doUnConfirm (){
         if (this.paramList.loadStatus != "BLC"){
            window.confirm('Load Status is not BLC')
            return;
         }

         const seqNo = this.paramList.seqNo;
         // const refDoc = this.params.loadKeyWithStageNo;
         //api
         //   .post("/api/w/apar/create", {
         newAPIPost("/api/w/apar/create", {
               mode: "APARUnCFM",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               salesOffice: this.paramList.salesOffice,
               refDoc: seqNo,
               billingNum: this.paramList.billingNumRateType
            })
            .then((res) => {
               this.showDialog = false;
               this.$store.commit("clearApiError");
               this.paramList.loadStatus = "CFM";
               this.params.loadStatus = "CFM";
               window.confirm(res);
               this.doSearch();
            });

         // api
         //    .post("/api/w/gst/WebConfirmLoad", {
         //       mode: "APARUnCFM",
         //       user: "GST_SYSTEM",
         //       username: this.getUserProfile.username,
         //       salesOffice: this.paramList.salesOffice,
         //       seqNo: seqNo,
         //       refDoc: seqNo,
         //       billingNum: this.paramList.billingNum
         //    })
         //    .then((res) => {
         //       this.showDialog = false;
         //       this.$store.commit("clearApiError");
         //       this.paramList.loadStatus = "CFM";
         //       this.params.loadStatus = "CFM";
         //       window.confirm(res);
         //       this.doSearch();
         //    });
         this.doSearch();

      },

      doConfirmStage(item) {
         if (this.getStageStatusCode(item.stageStatus) != "DCP"){
            window.confirm('Stage Status is not DCP')
            return;
         }

         if (item.costRelevant == "Cost Relevant(Y)"){
           if (item.driverId == "" || item.driverId == null){
              window.confirm('Driver information missing!')
              return;
           }

           if (this.getRateCostCode(item.freightType) == "" || this.getRateCostCode(item.freightType) == null){
              window.confirm('Freight Type information missing!')
              return;
           }

           const seqNo = this.paramList.seqNo;
           //api.post("/api/w/apar/create", {
           newAPIPost("/api/w/apar/create", {
             mode: "stageCFM",
             user: "GST_SYSTEM",
             username: this.getUserProfile.username,
            //  billingDate: dateFormat.getLocalDateOnly(moment().toDate()),
             billingDate: this.convertDateForConfirm(this.paramList.chzEndDate,"-"),
             refDoc: item.loadKeyWithStageNo,
             seqNo: seqNo,
             deliveryOrder: this.paramList.deliveryOrder,
             salesOffice: this.paramList.salesOffice,
             rateType: this.getRateCostCode(item.freightType),
             pf: "DR",
             partner: item.driverId,
             settleDate: moment(moment().endOf('week').toDate()).format('M/D/YYYY')

           })
           .then((res) => {
             item.stageStatus = "CFM";
             this.showDialog = true;
             this.$store.commit("clearApiError");
             window.confirm(res);
           });

         //   api.post("/api/w/gst/WebConfirmLoad", {
         //     mode: "stageCFM",
         //     user: "GST_SYSTEM",
         //     username: this.getUserProfile.username,
         //    //  billingDate: dateFormat.getLocalDateOnly(moment().toDate()),
         //     billingDate: this.convertDateForConfirm(this.paramList.chzEndDate,"-"),
         //     refDoc: item.loadKeyWithStageNo,
         //     seqNo: seqNo,
         //     deliveryOrder: this.paramList.deliveryOrder,
         //     salesOffice: this.paramList.salesOffice,
         //     rateType: this.getRateCostCode(item.freightType),
         //     pf: "DR",
         //     partner: item.driverId
         //   })
         //   .then((res) => {
         //     item.stageStatus = "CFM";
         //     this.showDialog = true;
         //     this.$store.commit("clearApiError");
         //     window.confirm(res);
         //   });
           this.doSearch();
         }

         if (item.costRelevant == "Cost Relevant(N)" || item.costRelevant == "Cost Relevant()" || item.costRelevant == null ){
           //api.post("/api/w/apar/create", {
           newAPIPost("/api/w/apar/create", {
             mode: "stageCMN",
             user: "GST_SYSTEM",
             username: this.getUserProfile.username,
             refDoc: item.loadKeyWithStageNo
           })
           .then((res) => {
             item.stageStatus = "CMN";
             this.showDialog = true;
             this.$store.commit("clearApiError");
             window.confirm(res);
           });

         //   api.post("/api/w/gst/WebConfirmLoad", {
         //     mode: "stageCMN",
         //     user: "GST_SYSTEM",
         //     username: this.getUserProfile.username,
         //     refDoc: item.loadKeyWithStageNo
         //   })
         //   .then((res) => {
         //     item.stageStatus = "CMN";
         //     this.showDialog = true;
         //     this.$store.commit("clearApiError");
         //     window.confirm(res);
         //   });
           this.doSearch();
         }
      },



      getItemIndx(indx, stage) {
         var itemindx = indx;
         var found = false;
         //console.log("items length: " + this.items.length);
         //console.log("getitemindex: stage: " + stage);
         this.items.forEach((it) => {
            //console.log("item stage: " + it.stage);
            if (it.stage != stage && !found) {
               itemindx += 1;
            }
            else { 
               //console.log("return in loop" + itemindx );
               //return itemindx;
               found = true;
            }
         }) 
         //console.log("return " + itemindx );
         //console.log("return -1");
         return itemindx;
         //return -1;
      },


      async onstagerefresh(id, ticket, mode, loads) {
         //console.log(`${id} , ${ticket} , ${mode}`);
         //console.log("assign booking - DO: " + id + ", BK#: " + ticket + ", item: " + loads);
         var itemlist = [];
         if (loads && loads != "") {
            this.items.forEach( (it) => {
               if (it.vueKey == loads && it.stageType == "EO") {
                  it.bookingNo = ticket;
                  it.deliveryOrder = id;
                  //console.log("onstagerefresh item: " + it);
                  itemlist.push(it);
               }   
            })
            // if (this.items.filter( it => it.vueKey == loads).length > 0) {
            //    console.log("onfresh item: " + JSON.stringify(this.items.filter( it => it.vueKey == loads)));
            //    this.items.filter( it => it.vueKey == loads).bookingNo = ticket;
            // }

         } else { //new
             //console.log("onfresh handle new item")
             this.items.forEach( (it) => {
               if (it.newitem && it.stageType == "EO") {
                  it.bookingNo = ticket;
                  it.deliveryOrder = id;
                  //console.log("onstagerefresh item: " + it);
                  itemlist.push(it);                  
               } 
             })
         }
         this.notifyMessage =  null;

         switch(mode)
         {
           case 'STR':
              this.notifyMessage = `Load ${id} has been scaled tw with scale ticket: ${ticket}.`;
           break;

           case 'SWR':
              this.notifyMessage = `Load ${id} with scale ticket: ${ticket} has been scaled gw.`;
           break;

           case 'ASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           case 'UASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           default:
           break;
         }
      
         //this.doSearch();
         if (itemlist.length > 0)
            this.doChkRemoveAndSave(itemlist[0]);

      },


      async onrefresh(id, ticket, mode, loads) {
         var onfresh_bookingNo = "";
         var onfresh_deliveryorder = "";
         //console.log(`${id} , ${ticket} , ${mode}`);
         //console.log("assign booking - DO: " + id + ", BK#: " + ticket + ", item: " + loads);
         var itemlist = [];
         if (loads && loads != "") {
            this.items.forEach( (it) => {
               if (it.vueKey == loads && it.stageType != "EO") {
                  it.bookingNo = ticket;
                  it.deliveryOrder = id;
                  onfresh_bookingNo = ticket;
                  onfresh_deliveryorder = id;
                  //console.log("onrefresh item: " + it);
                  itemlist.push(it);
               }   
            })
            // if (this.items.filter( it => it.vueKey == loads).length > 0) {
            //    console.log("onfresh item: " + JSON.stringify(this.items.filter( it => it.vueKey == loads)));
            //    this.items.filter( it => it.vueKey == loads).bookingNo = ticket;
            // }

         } else { //new
             //console.log("onfresh handle new item")
             this.items.forEach( (it) => {
               if (it.newitem && it.stageType != "EO") {
                  it.bookingNo = ticket;
                  it.deliveryOrder = id;
                  onfresh_bookingNo = ticket;
                  onfresh_deliveryorder = id;
                  //console.log("onrefresh item: " + it);
                  itemlist.push(it);                  
               } 
             })
         }
         this.paramList.bookingNo = onfresh_bookingNo;
         this.paramList.deliveryOrder = onfresh_deliveryorder;
         this.notifyMessage =  null;

         switch(mode)
         {
           case 'STR':
              this.notifyMessage = `Load ${id} has been scaled tw with scale ticket: ${ticket}.`;
           break;

           case 'SWR':
              this.notifyMessage = `Load ${id} with scale ticket: ${ticket} has been scaled gw.`;
           break;

           case 'ASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           case 'UASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           default:
           break;
         }
      
         //this.doSearch();
         if (itemlist.length > 0)
            this.doChkRemoveAndSave(itemlist[0]);
       },


      checkIsBookingAssigned(item) {
         //console.log("checkisbookingassigned: " + item.bookingNo);
         if (item.stageType == "EO") {
            if (item.stageBookingNo && item.stageBookingNo != "") 
               return true; 
            else 
               return false;
         } else {   
            if (item.bookingNo && item.bookingNo != "") 
               return true; 
            else 
               return false;
         }   
      }, 

      handleStageStatusChanged(stage) {
        return (id) => {
          stage.stageStatus = id;
        };
      },

      handleGradeChanged(item) {
         return(id) => {
            item.grade = id;
         }
      },

      handleChassisVendorChanged(item) {
         return (id) => {
            item.chassisVendor = id;
         }
      },

      handleCtnrTypeChanged(item) {
         return (id) => {
            item.ctnrType = id;
         } 
      },

      handleWindowsChanged(item) {
         return (id) => {
            item.receivingWindow = id;
         }
      },


      handleDriverChanged() {
         return (id, name, unit, weight, plate, trail) => {
          //console.log("itsm driverPh: " + item.driverPh);
          //item.driverPh = "";
          //console.log(`Item is ${item}`)
          //item.moveInBy = id;
          //item.driverPh = name;
          this.driverId = id;
          //console.log(`Phone is ${item.driverPh}`);
          //item.message = "3555";
          //this.$forceUpdate()
          //console.log("driverId: " + id);
          //console.log("selected Items driverPh: " + item.driverPh);
          //console.log("selected item index: " + item.index);
          //if (item.index > -1)
          //{
          //    console.log("selected item driverPh: " + this.smslist[item.index].driverPh);
          //}
          //if (document.getElementById("smsoutbound"))
          //{
          //   console.log("find smsoutbound element");
          //   document.getElementById("smsoutbound").refresh;
         // }
        };
      },

      handleTruckChanged(item) {
        return (id) => {
          item.truckId = id;
        };
      },
      handleCostRelChanged(item) {
        return (id) => {
          item.costRelevant = id; 
        };
      },
      handleCntrTypeChanged(item) {
        return (id) => {
          item.ctnrType = id;
        }
      },
      handleCtnrPickupLocChanged(item) {
        return (id) => {
          item.containerPickupLocation = id;
        }
      },
      handleCtnrDropOffLocChanged(item) {
         return (id) => {
          item.containerDropOffLocation = id;
        }
      },
      handleFreightTypeChanged(item) {
         return (id) => {
          //console.log("freight type id: " + id);
          item.freightType = id;
         }
          //item.freightType = id;
          //return id;
      },       


      handleCarrierChanged(item) {
         return (id, name, unit, weight, plate, trail) => {
            //console.log("handle carrier: " + id + ", " + name);
            item.carrier = id;
         }
      },
      handleRateCost(item) {
         //console.log("rate cost changed." + item.freightType);
         return (cost) => {
            //console.log("rate cost id: " + cost);
            item.freightType = cost;
         }
      },

      handleDropOffChanged(item) {
         return ((id) => {
            item.containerDropOffLocation = id;
         })
      },

      handlePickupTermChanged(item) {
         return ((id) => {
            item.containerPickupLocation = id;
         })
      },
      
      handleChassisPickupLocChanged(item) {
         return ((id) => {
            item.chassisPickupLocation = id;
         })
      },
      handleChassisPickupTermChanged(item) {
         return ((id) => {
            //console.log("chassis pickup term: " + id);
            item.chassisPickupTerm = id;
         })
      },
      handleChassisDropOffLocChanged(item) {
         return ((id) => {
            item.chassisDropOffLocation = id;
         })
      },
      handleChassisDropOffTermChanged(item) {
         return ((id) => {
            item.chassisDropOffTerm = id;
         })
      },
      handleChassisSizeChanged(item) {
         return ((id) => {
            item.chassisSize = id;
         })
      },
   

        doCancel(item){
            item.editing = false;
        },

        canEdit(item){
          return item.editing != null
      },

      async  doSearch()
    {
        this.isfromsearch = true;
        if (this.params != null)
        {
            const data = {
            seqNo: this.params.seqNo,
            companyOffice: 'GST_' + this.params.salesOffice,
            salesOffice: this.params.salesOffice,
                }
            // console.log(data);
            //await api.post("/api/w/gst/WebSearchCockpit", data)
            await newAPIPost("/api/w/gst/WebSearchCockpit", data)
          .then((item) => {
            this.$store.commit('clearApiError');
            item.forEach((it) => {
            it.editing = false;
            it.showDropDown2 = false;
            it.show = true;
            it.remove = false;
            it.newitem = false;
            if (it.containerNo != it.emptyoutContainerNo) {
               it.containerNo = it.emptyoutContainerNo;
            }
            if (it.chassisNo != it.emptyoutChassisNo) {
               it.chassisNo = it.emptyoutChassisNo;
            }
            it.driverId = this.getdriverFromUsername(it.driverId);
            it.freightType = this.getRateCostFromCode(it.freightType);
            it.chassisVendor = this.getDisplay("STC_CHASSIS_VENDOR",it.chassisVendor);
            it.ctnrType = this.getDisplay("GST_CTNRTYPE",it.ctnrType);
            it.apptDate = this.convertDateForDatePicker(it.apptDate);
            it.gwDate = this.convertDateForDatePicker(it.gwDate);
            it.inYardDate = this.convertDateForDatePicker(it.inYardDate);
            it.chzEndDate = this.convertDateForDatePicker(it.chzEndDate);
            it.chzEndDate = this.convertDateForDatePicker(it.chzEndDate);
            it.chzStartDate = this.convertDateForDatePicker(it.chzStartDate);
            it.chassisPickupLocation = this.getLocFromCode(it.chassisPickupLocation);
            it.chassisPickupTerm = this.getTermFromCode(it.chassisPickupTerm);
            it.chassisDropOffLocation = this.getLocFromCode(it.chassisDropOffLocation);
            it.chassisDropOffTerm = this.getTermFromCode(it.chassisDropOffTerm);
            it.stageStatus = this.getStageStatusFromCode(it.stageStatus);
            it.costRelevant = this.getCostRelFromCode(it.costRelevant);
            it.chassisSize = this.getChassisSizeFromCode(it.chassisSize);
            it.chzUseDay = it.chzUseDay;
            if (it.ctnrPicConfirmed == "true")
                it.ctnrPicConfirmed = true;
            else
                it.ctnrPicConfirmed = false;
            if (it.chassisPicConfirmed == "true")
                it.chassisPicConfirmed = true;
            else
                it.chassisPicConfirmed = false;
            if (it.interTicketPicConfirmed == "true")
                it.interTicketPicConfirmed = true;
            else
                it.interTicketPicConfirmed = false;                     
          });

            this.items = item;
 
          });

        }
    },

    getBookingAssign(item) {
         //const loads = this.getSelectedItems
         //console.log("getBookingAssign")
         var loads = [];
         var bkAssignItem = item;
         bkAssignItem.ctnrType = this.getContentFromBrace(bkAssignItem.ctnrType);
         loads.push(bkAssignItem);
         //if (item.newitem) { alert("Please save the new record before process BK assign"); return; }
         if (this.paramList.carrier == null || this.paramList.grade == null) {
            alert("Either carrier or grade in container is empty, please setup info and assign again!!");
         } else {
            this.$refs.OutboundBooking.openDialog(loads);
            //item.bookingNo = "";
            //this.disableAsgBk = true;
            //this.disableUnAsgBk = false;
            //this.doChkRemoveAndSave(item);
         }
      },

    getBookingAssignEmptyOut(item) {
      //console.log("Empty out assign booking");
      if (item.newitem) {
         alert("Please save the new item before process the assignment.");
         return;
      }   
      var loads = [];
         var bkAssignItem = item;
         bkAssignItem.ctnrType = this.getContentFromBrace(bkAssignItem.ctnrType);
         loads.push(bkAssignItem);
         //if (item.newitem) { alert("Please save the new record before process BK assign"); return; }
         if (this.paramList.carrier == null) {
            alert("Either carrier or grade in container is empty, please setup info and assign again!!");
         } else {
            //console.log("calling empty out assign booking component");
            this.$refs.EmptyOutAssignBooking.openDialog(loads);
            //item.bookingNo = "";
            //this.disableAsgBk = true;
            //this.disableUnAsgBk = false;
            //this.doChkRemoveAndSave(item);
         }
    },


getBookingUnAssign(item) {
         if (!window.confirm('Unassign Selected Items?')) {
           //this.disableAsgBk = true;
           //this.disableUnAsgBk = false; 
           return;
         }
        
         //const load = this.getSelectedItems
         // var loads = [];
         // loads.push(item);
         // const office = 'LGB'
         // const si = loads[0].deliveryOrder
         // const obk = loads[0].bookObl
         // const ibds = loads[0].ibs
         // const usr = 'GST_SYSTEM'
         // const seqn = loads[0].seqNo
         const office = 'LGB';
         const si = this.paramList.deliveryOrder;
         //const si = item.deliveryOrder;
         //const obk = this.paramList.bookingNo;
         const obk = item.bookingNo;
         const ibds = this.paramList.ibs;
         const usr = 'GST_SYSTEM';
         //const seqn = this.paramList.seqNo;
         const seqn = item.seqNo;
         //console.log("Set Unassign");
         const request = {
           salesOffice: office,
           deliveryOrder: si,
           ibs: ibds,
           user: usr,
           seqNo: seqn,
         };

         //console.log(JSON.stringify(request));
         //api.post("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
         newAPIPost("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            //this.action(si, obk, 'UASN', seqn);
            item.bookingNo = "";
            item.deliveryOrder = "";
            this.paramList.bookingNo = "";
            this.doChkRemoveAndSave(item);
 
         });
    },

getBookingUnAssignEmptyOut(item) {
       //console.log("Empty out unassign booking");
       if (!window.confirm('Unassign Selected Items?')) {
           //this.disableAsgBk = true;
           //this.disableUnAsgBk = false; 
           return;
       }
       const office = 'LGB';
       const si = this.paramList.deliveryOrder;
       //const si = item.deliveryOrder;
       //const obk = this.paramList.bookingNo;
       //const obk = item.bookingNo;
       //const ibds = this.paramList.ibs;
       //const usr = 'GST_SYSTEM';
       //const seqn = this.paramList.seqNo;
       //const seqn = item.seqNo;
       const loadkeywithstageno = item.loadKeyWithStageNo;
       //console.log("Set Unassign");
       const request = {
         salesOffice: office,
         deliveryOrder: si,
         //ibs: ibds,
         //user: usr,
         //seqNo: seqn,
         loadKeyWithStageNo: loadkeywithstageno
       };

       //console.log(JSON.stringify(request));
       //api.post("/api/w/stc/WebStageUnAssignBooking", request).then((res) => {
       newAPIPost("/api/w/stc/WebStageUnAssignBooking", request).then((res) => {
         this.showDialog = false;
         this.$store.commit("clearApiError");
         //this.action(si, obk, 'UASN', seqn);
         item.bookingNo = "";
         item.deliveryOrder = "";
         this.paramList.bookingNo = "";
         this.doChkRemoveAndSave(item);
 
       });

    },


    convertDateForDatePicker(date) {
        var day = "";
        var month = "";
        var year = "";

        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          if (date.indexOf("T") < 1 && date.indexOf("-") > 1) date = date + "T00:00:00" 
          console.log("date input after checking with T: " + date);
          var processDate = new Date(date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          //month = processDate.getMonth();
          day = processDate.getDate();
          //console.log("date input before process:- year: " + year + ", month: " + month + ", date: " + day );
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          return date;
        }
     },

convertDateForConfirm(date, separator) {
        var day = "";
        var month = "";
        var year = "";
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          var processDate = new Date(date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          if (separator && separator == "-")
              return year + separator + month + separator + day;
          else 
              return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
      },


    getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  //console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  //console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
    },

    getdriverUserNameFromDriver(driver) {
         return this.getContentFromBrace(driver);
    },

    getRateCostCode(RateCost) {
         var retVal = this.getContentFromBrace(RateCost);
         //console.log("Rate cost return: " + retVal);
         return retVal;
    },

    getchassisVendorCode(vendor) {
         return this.getContentFromBrace(vendor);
    },

    getChassisSizeCode(size) {
         return this.getContentFromBrace(size);
    },
    
    getStageStatusCode(status) {
         return this.getContentFromBrace(status);
    },
    getSTCTerminal() {
         //const terminals = this.getMasterDataByGroup("GST_TERMINAL").filter( it => it.from == "STC");
         const terminals = this.getMasterDataByGroup("STC_TERMINAL");
         //console.log("termainals: " + JSON.stringify(terminals));
         //var retTerm = [];
         terminals.forEach((it) => {
            //console.log("termname: " + it.tagName + ", term id" + it.tagId);
            this.terminals.push(it.tagName + "(" + it.tagId + ")");
         })
         //console.log("this terminals: " + this.terminals);
         //return retTerm;
    },
    getdriverFromUsername(username) {
         var indx = 0;
         var findIndx = -1;
         if (username && username != "") {
            this.driverNames.forEach( (it) => {
               if (it == username) {
                  findIndx = indx;
               }
               indx += 1;
            })
            if (findIndx > -1) {
               return this.drivers[findIndx];
            } else {
               return username;
            }
         } else {
            return username;
         }
    },
    getLocFromCode(code) {
       var tagname = this.getMasterDataName("GST_LOCATION",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getTermFromCode(code) {
      var tagname = this.getMasterDataName("STC_TERMINAL",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getStageStatusFromCode(code) {
      var tagname = this.getMasterDataName("GST_STAGE_STATUS",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getCostRelFromCode(code) {
      var tagname = this.getMasterDataName("STC_COSTREL_STATUS",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;
    },
    getChassisSizeFromCode(code) {
      var tagname = this.getMasterDataName("GST_CTNRTYPE",code);
       var retVal = "";
       if (!tagname) retVal = code; else retVal = tagname + "(" + code + ")";
       return retVal;

    },
    getRateCostFromCode(code) {
         var indx = 0;
         var findIndx = -1;
         if (code && code != "") {
            this.dispRateCostCodes.forEach( (it) => {
               if (it == code) {
                  findIndx = indx;
               }
               indx += 1;
            })
            if (findIndx > -1) {
               return this.dispRateCostList[findIndx];
            } else {
               return code;
            }
         } else {
            return code;
         }
    },

    getDisplay(group, tagId) {
      var tagname = "";
      if (!tagId) {
        return "";
      }
      tagname = this.getMasterDataName(group, tagId) || tagId;
      //console.log("getdisplay tagname: " + tagname);
      return tagname + " (" + tagId + ")";
    },


    getStageTypeInfo(type) {
       var retType = "";
       //console.log("in stage type: " + type);
       if (type && type != "") {
          //retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          //console.log("return type: " + retType);
       }
       if (retType == "") {
          return "In Gate";
       }   
       else {
          return retType;     
       }
    },
    getPushStatusInfo(status) {
       var retStatus = "";
       //console.log("push status: " + status);
       if (status && status != "") {
          //retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          retStatus = this.getMasterDataName("PUSH_STATUS",status);
          //console.log("return type: " + retStatus);
       }
       return retStatus;     
    },
    setStageWindow(type) {
       if (type == "I" || type == "O" || type == "T") {
          this.showChzOut = false;
          this.showInOutTrans = true;
       } else {
         if (type == "CO") {
             this.showChzOut = true;
             this.showInOutTrans = false;
         }
         else {
             this.showChzOut = false;
             this.showInOutTrans = false;
         }
       }

          
    },
    getFreightType() {
        return  this.getMasterDataAsSelectOptionByGroup('GST_RATE_COST');
        
      },
    initShowStageType() {
       this.showLISel = false;
       this.showLOSel = false;
       this.showEISel = false;
       this.showEOSel = false;
       this.showCISel = false;
       this.showCOSel = false;
       this.showTSel = false;
       this.showRSel = false;
    },  

    checkStageTypeListOpt(type) {
      var group = "STC_LOAD_STAGES_" + type;
      console.log("load stages group: " + group);
      const opts =  this.getMasterDataByGroup(group);
      //console.log("stage type opt: " + opts + " opt length: " + opts.length); 
      this.initShowStageType();
      if (opts && opts.length >= 0) {
         var opt = opts[0];      
         var tagid = "";
         for (opt in opts) {
            //console.log("load stage: " + opts[opt].tagId);
            tagid = opts[opt].tagId;
            if (tagid == "LI") this.showLISel = true;
            if (tagid == "LO") this.showLOSel = true;
            if (tagid == "EI") this.showEISel = true;
            if (tagid == "EO") this.showEOSel = true;
            if (tagid == "CI") this.showCISel = true;
            if (tagid == "CO") this.showCOSel = true;
            if (tagid == "R") this.showRSel = true;
            if (tagid == "T") this.showTSel = true;
         }
      }
      // for (var opt in opts) {
      //    console.log("stages: " + opt);
      // }
      // opts.forEach( (it) => {
      //    console.log("opts loop");
      //    if (it.tagId == "LI") this.showLISel = true; else this.showLISel = false;
      //    if (it.tagId == "LO") this.showLOSel = true; else this.showLOSel = false;
      //    if (it.tagId == "EI") this.showEISel = true; else this.showEISel = false;
      //    if (it.tagId == "EO") this.showEOSel = true; else this.showEOSel = false;
      //    if (it.tagId == "CI") this.showCISel = true; else this.showCISel = false;
      //    if (it.tagId == "CO") this.showCOSel = true; else this.showCOSel = false;
      //    if (it.tagId == "T") this.showTSel = true; else this.showTSel = false; 
      // })
    },

    isToShowInOutTrans(type) {
      if (type == "I" || type == "O" || type == "T") 
         return true;
      else 
         return false;
    },
    isToShowChzOut(type) {
      if (type == "CO") 
         return true;
      else 
         return false;
    },
    isToShowLoadIn(type) {
      //console.log("isToShowLoadIn type: " + type);
      if (type == "LI")
        return true;
      else
        return false;  
    },
    isToShowLoadOut(type) {
      if (type == "LO")
         return true;
      else
         return false;   
    },
    isToShowEmptyOut(type) {
      if (type == "EO")
         return true;
      else
         return false;   
    },
    isToShowEmptyIn(type) {
      if (type == "EI")
         return true;
      else
         return false;   
    },
    isToShowChassisOut(type) {
      if (type == "CO")
         return true;
      else
         return false;   
    },
    isToShowChassisIn(type) {
      if (type == "CI")
         return true;
      else
         return false;   
    },
    isToShowTransfer(type) {
      if (type == "T")
         return true;
      else
         return false;   
    },
    isToShowReuse(type) {
      if (type == "R")
         return true;
      else
         return false;   
    },

    getDate(date) {
      var separator = "T";
      if (date) {
         if (date.toString().indexOf(separator) > 0) {
            return date.toString().substr(0,date.toString().indexOf(separator));
         }
         else
         {
            return date.toString();
         }         
      }
      else {
         return "";
      }

    },
   //  getChassisUsedDate(item){
   //        console.log("chzStartDate: " + item.chzStartDate + " chzEndDate: " + item.chzEndDate);
   //        if (item.chzEndDate == null)
   //        {
   //          return moment().diff(moment(item.chzStartDate), 'days') + " days";
   //        }
   //        else
   //        {
   //          return moment(item.chzEndDate).diff(moment(item.chzStartDate), 'days') + " days";
   //        }
   //    },
      doDropDown() {
          this.showDropDown = !this.showDropDown;
      },
      doDropDown2(item) {
          if (item.showDropDown2 == null) {
             item.showDropDown2 = true;
             //console.log("dodropdown2 is null and set: " + item.showDropDown2); 
          }   
          else {   
             console.log("dodropdown2 is: " + item.showDropDown2); 
             item.showDropDown2 = !item.showDropDown2; 
             //console.log("dodropdown2 is now: " + item.showDropDown2); 
          }   
      }, 
      doHide() {
          this.loadHide = !this.loadHide;
      },     
      toShowDropDown2(item) {
         //console.log("toshowdropdown2: ",item);
         if (item.showDropDown2) { 
            //console.log('showdropdown2 return true'); 
            return true;}
         else {
            //console.log('showdropdown2 return false'); 
            return false;}
      } 
    }
    }


</script>

<style scoped>

.custButton {
    margin: 10px;
    width: 110px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}

.custLongButton {
    margin: 10px;
    width: 180px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}


/* .holder {

    margin: 20px;
    width: 800px;
    height: 200px;
} */

.header{
    text-align: left;
}

.fixed-content {
    padding-left: 10%;
    padding-right: 10%;
    position:fixed;
    overflow-y:auto;
    overflow-x:hidden;
}

.md-layout-item {
  height: 50px;
  background: rgb(234, 242, 238);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  /* border:1px solid #000; */
  /* background: #ce93d8; */
}

 .md-table-row{
   background: rgb(217, 245, 245);
 }

.md-title {
    margin-left: 20px;
}
.md-titleINV {
    margin-left: 10px;
    font-size: 20px;
    color: black;
}
.md-titleINVCont {
    margin-left: 10px;
    font-size: 18px;
    color: blue;
}

.md-titleAR {
    margin-left: 5px;
    font-size: 18px;
    color: #2980B9;
}
.md-titleAP {
    margin-left: 5px;
    font-size: 18px;
    color: #2980B9;
}
.fieldWidth {
   width: 80px !important;
}





</style>